import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import TableComponent from "../../../components/tableComponent/TableComponent";
import {
  fetchGradeRequest,
  fetchMarkRequest,
  fetchSaleNumbersRequest,
  teaTypeAction,
} from "../../../store/actions";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import axiosMain from "../../../http/axios/axios_main";
import CreatePlanner from "./CreatePlanner";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import * as Yup from "yup";
import {
  SelectionState,
  PagingState,
  IntegratedPaging,
  IntegratedSelection,
  SortingState,
  IntegratedSorting,
  EditingState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  TableSelection,
  PagingPanel,
  TableColumnReordering,
  DragDropProvider,
  TableColumnResizing,
  TableEditRow,
  TableInlineCellEditing,
  TableFixedColumns,
  VirtualTable,
} from "@devexpress/dx-react-grid-bootstrap4";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";

import DeleteConfirmationModal from "../../../components/common/DeleteConfirmationModal";
import CustomToast from "../../../components/Toast";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  Typography,
} from "@mui/material";
import ToCreateMyPlanner from "./ToCreateMyPlanner";
import { usePrint } from "../../../components/common/PrintDataInTable";
// import PrintableTable from "../../../components/common/PrintableTable";
import UploadValuation from "./UploadValuation";
import UpdateValuation from "./UpdateValuation";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";
import formatDateToDdMmYy from "../../../components/common/dateAndTime/convertToDate";
import ExportData from "../../../components/common/exportData/ExportData";
import { Button, Table as BootstrapTable } from "react-bootstrap";

import "./table.css";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import axios from "axios";
import PrintInvoice from "../../../components/common/Print/print";
import Modals from "../../../components/common/Modal";
import newformatDateToDdMmYy from "../../../components/common/dateAndTime/newconvertToDate";
import { useLoader } from "../../../components/common/Loder/Loder";
import removeSeconds from "../../../components/common/dateAndTime/timeFormat";
import {
  ExportHTMl,
  ExportPDF,
} from "../../../components/common/DownloadTable";
import PrintableTable from "../../../components/common/PrintableTable";
import "./dataTable.css";

// console.log(loggedUser, "loggedUserloggedUser");
const tableMessages = {
  noData: "No Records Found",
};

const requiredRule = {
  isValid: (value) => value?.trim().length > 0,
  errorText: "This field is required",
};
const validationRules = {
  // phone: {
  //   isValid: (phone) => phone.match(/^\(\d{3}\) \d{3}-\d{4}$/i),
  //   errorText: 'Your phone must have "(555) 555-5555" format!',
  // },
  netKgs: requiredRule,
  invoiceQty: requiredRule,
  grossKgs: requiredRule,
};

const validate = (changed, validationStatus) =>
  Object.keys(changed).reduce((status, id) => {
    let rowStatus = validationStatus[id] || {};
    if (changed[id]) {
      rowStatus = {
        ...rowStatus,
        ...Object.keys(changed[id]).reduce((acc, field) => {
          const isValid = validationRules[field].isValid(changed[id][field]);
          return {
            ...acc,
            [field]: {
              isValid,
              error: !isValid && validationRules[field].errorText,
            },
          };
        }, {}),
      };
    }

    return { ...status, [id]: rowStatus };
  }, {});

const AuctionCatalog = ({ modalRight, open }) => {
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    auction,
    auctionTypeMasterCode,
    roleCode,
  } = useAuctionDetail();

  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();

  const [auctionType, setAuctionType] = useState(auction);
  const [auctionTypeCode, setAuctionTypeCode] = useState(auctionTypeMasterCode);
  const [baseUrlEng, setBaseUrlEng] = useState(
    auction === "ENGLISH" ? "EnglishAuctionCatalog" : "AuctionCatalog"
  );
  const [baseUrlEngBuyer, setBaseUrlEngBuyer] = useState(
    auction === "ENGLISH" ? "EnglishAuctionBuyer" : "Buyer"
  );

  const [auctionCatalogUrl, setAuctionCatalogUrl] = useState(
    open === "auctioncatalog"
      ? baseUrlEng
      : open === "auctioncatalogBuyer"
      ? baseUrlEngBuyer
      : ""
  );

  const [userRole, setUserRole] = useState(
    open === "auctioncatalog"
      ? "auctioneer"
      : open === "auctioncatalogBuyer"
      ? "buyer"
      : loggedUser?.userCode
  );

  const [originDataList, setOriginDataList] = useState([]);

  const [rows, setRows] = useState([]);
  const [expandedTab, setExpandedTab] = useState("All");

  const [saleNo, setSaleNo] = useState([]);
  const [auctioneer, setAuctioneer] = useState([]);
  const [teatypeList, setTeaType] = useState([]);
  const [auctionDates, setAuctionDates] = useState([]);
  const [category, setCategory] = useState([]);
  const [sessionTime, setSessionTime] = useState([]);
  const [timeData, setTimeData] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [myCatalogRows, setMyCatalogRows] = useState([]);
  const [openMyPlanner, setOpenMyPlanner] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selection, setSelection] = useState([]);
  const [sessionTypeId, setsessionTypeId] = useState(0);
  const [auctioncatalogIdforupload, setauctioncatalogIdforupload] = useState(0);

  const [saleProgramId, setSaleProgramId] = useState(null);
  const [selectedDataMyCatalogdata, setSelectedDataMyCatalogdata] = useState(
    []
  );
  const [selectedDataAuctionCatalogdata, setSelectedDataAuctionCatalogdata] =
    useState([]);
  const [openUploadValuation, setOpenUploadValuation] = useState(false);
  const [getDataByPrems, setGetDataByprems] = useState([]);
  const [openUploadUpdateValuation, setOpenUploadUpdateValuation] =
    useState(false);
  const [selectionAuctionerList, setSelectionAuctionerList] = useState([]);

  const [editData, setIsEditData] = useState([]);
  const [loggedUser, setLoggedUser] = useState(
    JSON.parse(localStorage.getItem("User"))
  );
  const [isEdit, setIsEdit] = useState(false);

  const { printContent } = usePrint();
  const isDropdownOpen = useRef(false);

  const teaType = useSelector(
    (state) => state.teaType.teaTypeList.responseData
  );

  const saleNumber = useSelector(
    (state) => state?.CreatedSaleNo?.saleNumbers?.responseData
  );
  const [markDataList, setMarkDataList] = useState([]);
  const [gradesList, setGradesList] = useState([]);

  const dispatch = useDispatch();
  const grades = useSelector((state) => state.grade.data.responseData);
  const markList = useSelector((state) => state.mark.data.responseData);
  const [openPrintModel, setopenPrintModel] = useState(false);
  const [openPrintModelMyCatalog, setopenPrintModelMyCatalog] = useState(false);
  const [printrow, setprintrow] = useState([]);
  const [columndata, setcolumndata] = useState([]);
  const [columndatamycatalog, setcolumndatamycatalog] = useState([]);
  const [printMyrow, setprintMyrow] = useState([]);

  const [openModalConformation, setOpenModalConformation] = useState(false);
  const [dataFlag, setDataFlag] = useState(false);
  const [openModalConformationTitle, setOpenModalConformationTitle] =
    useState("");
  const [changed, setchanged] = useState({});
  const [myValuation, setMyValuation] = useState(0);

  const [editableCell, setEditableCell] = useState({
    rowId: null,
    columnName: null,
  });
  const [groupCode, setGroupCode] = useState([]);
  const inputRefs = useRef([]);
  const selectRefs = useRef([]);
  const tableRef = useRef(null);

  const [myCatalogForBuyer, setMyCatalogForBuyer] = useState(
    auctionCatalogUrl === "EnglishAuctionBuyer"
      ? [
          // {
          //   title: "Select",
          //   name: ".",
          //   getCellValue: ({ ...row }) => (
          //     <>
          //       <input
          //         type="checkbox"
          //         checked={selectedDataMyCatalogdata.some(
          //           (selectedRow) => selectedRow.MyCatalogId === row.MyCatalogId
          //         )}
          //         onChange={() => handleCheckboxChangeMyCatalog(row)}
          //       />
          //     </>
          //   ),
          // },
          { title: "Season", name: "season" },
          { title: "Sale No.", name: "saleNo" },
          {
            title: "Auction Date",
            name: "auctionDate",
            getCellValue: ({ ...row }) => row.auctionDate?.split("T")?.at(0),
          },
          // { title: "Tea Type", name: "teaTypeName" },
          { title: "Category", name: "categoryName" },
          { title: "Session Time", name: "sessionTime" },
          // { title: "Lot No.", name: "lotNo" },
          { title: "Origin", name: "origin" },
          { title: "Tea Type", name: "teaTypeName" },
          { title: "Sub Type", name: "subTeaTypeName" },
          // { title: "Category", name: "categoryName" },
          { title: "Mark", name: "markName" },
          { title: "Grade", name: "gradeName" },
          { title: "Group Code", name: "groupCode" },
          { title: "No. of Packages", name: "totalPackages" },
          { title: "Gross Weight", name: "grossKgs" },
          // { title: "Tare Weight", name: "tareKgs" },
          { title: "Net Weight", name: "netKgs" },
          { title: "Invoice Weight", name: "invoiceQty" },
          {
            title: "Period of Manufacture (From to To)",
            name: "periodOfManufacture",
          },
          { title: "Base Price", name: "basePrice" },
          // { title: "Price Increment", name: "priceIncrement" },
          { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
          { title: "LSP/SP", name: "LSP_SP" },
          { title: "Mark & Packaging Comments", name: "markPackageComments" },
          { title: "Lot Comments", name: "lotComments" },
          { title: "Market Type (Lot Type)", name: "lotType" },
          { title: "My Comments", name: "myComments" },
          { title: "My Valuation", name: "myValuation" },
          { title: "GP No.", name: "gpNo" },
          { title: "GP Date", name: "gpDate" },
          { title: "Invoice No.", name: "invoiceNo" },
          { title: "Package Type", name: "packageType" },
          { title: "Package No.", name: "packageNo" },
          { title: "Warehouse Unit Code", name: "wareHouseName" },
          // { title: "Garden Certification", name: "gardenCertification" },
          // { title: "Quality Certification", name: "qualityCertification" },
          // { title: "Color of Brew", name: "brewColor" },
          // { title: "Age of Products (In Months)", name: "ageOfProducts" },
          // { title: "Brewers Comments", name: "brewersComments" },

          // { title: "Sample Qty. (KGs)", name: "SampleQty" },

          // { title: "Reserve Price", name: "reservePrice" },

          // { title: "LSP / SP", name: "LSP_SP" },
          // { title: "Quality Comments", name: "qualityComments" },

          // { title: "System Base Price", name: "basePrice" },

          {
            title: "Action",
            name: "action",
            // getCellValue: ({ ...row }) => (
            //   <>
            //     <button
            //       type="button"
            //       onClick={() => {
            //         setOpenMyPlanner(true);
            //         setIsEdit(true);
            //       }}
            //     >
            //       Remove
            //     </button>
            //     {/* <button type="button" onClick={() => setOpenMyPlanner(true)}>
            //       Add Valuation
            //     </button> */}
            //   </>
            // ),
          },
        ]
      : [
          // {
          //   title: "Select",
          //   name: ".",
          //   getCellValue: ({ ...row }) => (
          //     <>
          //       <input
          //         type="checkbox"
          //         checked={selectedDataMyCatalogdata.some(
          //           (selectedRow) => selectedRow.MyCatalogId === row.MyCatalogId
          //         )}
          //         onChange={() => handleCheckboxChangeMyCatalog(row)}
          //       />
          //     </>
          //   ),
          // },
          { title: "Season", name: "season" },
          { title: "Sale No.", name: "saleNo" },
          {
            title: "Auction Date",
            name: "auctionDate",
            getCellValue: ({ ...row }) => row.auctionDate?.split("T")?.at(0),
          },
          // { title: "Tea Type", name: "teaTypeName" },
          { title: "Category", name: "categoryName" },
          { title: "Session Time", name: "sessionTime" },
          // { title: "Lot No.", name: "lotNo" },
          { title: "Origin", name: "origin" },
          { title: "Tea Type", name: "teaTypeName" },
          { title: "Sub Type", name: "subTeaTypeName" },
          // { title: "Category", name: "categoryName" },
          { title: "Mark", name: "markName" },
          { title: "Grade", name: "gradeName" },
          { title: "Group Code", name: "groupCode" },
          { title: "No. of Packages", name: "totalPackages" },
          { title: "Gross Weight", name: "grossKgs" },
          // { title: "Tare Weight", name: "tareKgs" },
          { title: "Net Weight", name: "netKgs" },
          { title: "Invoice Weight", name: "invoiceQty" },
          {
            title: "Period of Manufacture (From to To)",
            name: "periodOfManufacture",
          },
          { title: "Base Price", name: "basePrice" },
          { title: "Price Increment", name: "priceIncrement" },
          { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
          { title: "LSP/SP", name: "LSP_SP" },
          { title: "Mark & Packaging Comments", name: "markPackageComments" },
          { title: "Lot Comments", name: "lotComments" },
          { title: "Market Type (Lot Type)", name: "marketTypeName" },
          { title: "My Comments", name: "myComments" },
          { title: "My Valuation", name: "myValuation" },
          { title: "GP No.", name: "gpNo" },
          { title: "GP Date", name: "gpDate" },
          { title: "Invoice No.", name: "invoiceNo" },
          { title: "Package Type", name: "packageType" },
          { title: "Package No.", name: "packageNo" },
          { title: "Warehouse Unit Code", name: "wareHouseName" },
          { title: "Garden Certification", name: "gardenCertification" },
          { title: "Quality Certification", name: "qualityCertification" },
          { title: "Color of Brew", name: "brewColor" },
          { title: "Age of Products (In Months)", name: "ageOfProducts" },
          { title: "Brewers Comments", name: "brewersComments" },

          {
            title: "Action",
            name: "action",
          },
        ]
  );

  const [myCatalogForAuctioneer, setMyCatalogForAuctioneer] = useState(
    auctionCatalogUrl === "AuctionCatalog"
      ? [
          // {
          //   title: ".",
          //   name: ".",
          //   // getCellValue: ({ ...row }) => (
          //   //   <>
          //   //     <input
          //   //       type="checkbox"
          //   //       onClick={() => setSelectedData([...selectedData, row])}
          //   //     />
          //   //   </>
          //   // ),
          // },
          // { title: "Season", name: "Season" },
          // { title: "Sale No.", name: "saleNo" },
          // { title: "Auction Date", name: "saleDate" },
          // { title: "Tea Type", name: "teaTypeName" },
          // { title: "Category", name: "categoryName" },
          // { title: "Session Type", name: "sessionType" },
          // { title: "Lot No.", name: "LotNo" },
          { title: "Mark", name: "markName" },
          { title: "Invoice No.", name: "invoiceNo" },
          { title: "Grade", name: "gradeName" },

          { title: "No. of Packages", name: "totalPackages" },
          { title: "Base Price", name: "basePrice" },
          { title: "Reserve Price", name: "reservePrice" },
          { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
          { title: "Price Increment", name: "priceIncrement" },
          { title: "LSP / SP", name: "LSP_SP" },
          { title: "Quality Comments", name: "qualityComments" },
          { title: "Origin", name: "Origin" },
          { title: "Sub Type", name: "subTeaTypeName" },
          { title: "Package Type", name: "packageType" },
          { title: "Package No.", name: "packageNo" },
          { title: "Gross Weight", name: "grossKgs" },
          { title: "Tare Weight", name: "tareKgs" },
          { title: "Net Weight", name: "netKgs" },
          { title: "Sample Qty. (KGs)", name: "SampleQty" },
          { title: "Invoice Weight", name: "invoiceWeight" },
          { title: "Short accses Weight", name: "ShortExcessWeight" },
          { title: "GP No.", name: "gpNo" },
          { title: "GP Date", name: "gpDate" },
          {
            title: "Period of Manufacture (From to To)",
            name: "periodOfManufacture",
          },
          { title: "Mark & Packaging Comments", name: "markPackageComments" },
          { title: "Market Type (Lot Type)", name: "marketTypeName" },
          { title: "Warehouse Unit Code", name: "wareHouseName" },
          { title: "Last Modified By", name: "lastModifiedBy" },
          { title: "Garden Certification", name: "gardenCertification" },
          { title: "Quality Certification", name: "qualityCertification" },
          { title: "Color of Brew", name: "brewColor" },
          { title: "Age of Products (In Months)", name: "ageOfProducts" },
          { title: "Brewers Comments", name: "brewersComments" },
          { title: "System Base Price", name: "SBP" },
          { title: "SBP_LSP/SP", name: "SBP_LSP_SP" },
          //--{ title: "My Comments", name: "lotComments" },
          //--{ title: "My valuation", name: "marketTypeName" },
          // { title: "Group Code", name: "groupCode" },

          //  { title: "Lot Comments", name: "lotComments" },

          //

          //

          //{ title: "System Base Price", name: "SBP" },
          //{ title: "SBP_LSP/SP", name: "SBP_LSP_SP" },
          {
            title: "Action",
            name: "action",
          },
          // { title: "My Comments", name: "myComments" },
          // { title: "My Valuation", name: "myValuation" },

          // { title: "Short accses Weight", name: "shortAccsesWeight" },
        ]
      : [
          // { title: "Season", name: "Season" },
          // { title: "Sale No.", name: "saleNo" },
          // { title: "Auction Date", name: "saleDate" },
          // { title: "Tea Type", name: "teaTypeName" },
          // { title: "Category", name: "categoryName" },
          // { title: "Session Time", name: "sessionTime" },
          // { title: "Lot No.", name: "LotNo" },
          { title: "Mark", name: "markName" },
          { title: "Invoice No.", name: "invoiceNo" },
          { title: "Grade", name: "gradeName" },
          { title: "No. of Packages", name: "totalPackages" },
          { title: "Base Price", name: "basePrice" },
          { title: "Reserve Price", name: "reservePrice" },
          { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
          // { title: "Price Increment", name: "priceIncrement" },
          { title: "LSP / SP", name: "LSP_SP" },
          { title: "Lot Comments", name: "lotComments" },
          { title: "Quality Comments", name: "qualityComments" },
          { title: "Origin", name: "Origin" },
          { title: "Tea Type", name: "teaTypeName" },
          { title: "Sub Tea Type", name: "subTeaTypeName" },
          { title: "Category", name: "categoryName" },
          // { title: "Group Code", name: "groupCode" },
          { title: "Package Type", name: "packageType" },
          { title: "Package No.", name: "packageNo" },
          { title: "Gross Weight", name: "grossKgs" },
          { title: "Tare Weight", name: "tareKgs" },
          { title: "Net Weight", name: "netKgs" },
          { title: "Sample Qty. (KGs)", name: "SampleQty" },
          { title: "Invoice Weight", name: "invoiceWeight" },
          { title: "Short Excess Weight", name: "ShortExcessWeight" },
          { title: "GP No.", name: "gpNo" },
          { title: "GP Date", name: "gpDate" },
          {
            title: "Period of Manufacture (From to To)",
            name: "periodOfManufacture",
          },
          // category, teatype, short excess weight, quality comments, last modified by,market type
          // { title: "Quality Comments", name: "qualityComments" },
          { title: "Mark & Packaging Comments", name: "markPackageComments" },
          { title: "Market Type / Lot Status", name: "lotStatus" },
          // { title: "Market Type (Lot Type)", name: "marketTypeName" },
          { title: "Warehouse Unit Code", name: "wareHouseName" },
          { title: "Last Modified By", name: "lastModifiedBy" },
          // { title: "Garden Certification", name: "gardenCertification" },
          // { title: "Quality Certification", name: "qualityCertification" },
          // { title: "Color of Brew", name: "brewColor" },
          // { title: "Age of Products (In Months)", name: "ageOfProducts" },
          // { title: "Brewers Comments", name: "brewersComments" },
          // { title: "System Base Price", name: "SBP" },
          // { title: "SBP_LSP/SP", name: "SBP_LSP_SP" },
          {
            title: "Action",
            name: "action",
          },
        ]
  );
  const [rowColorchange, setRowcolorChange] = useState(null);
  // const commitChanges = (row, id, columnName) => {
  //   const newValue = inputRefs.current[id]?.value || "";
  //   handleValuationChange(newValue, id, columnName);
  //   setEditableCell({ rowId: null, columnName: null });

  // };
  const validationSchema =
    userRole === "buyer"
      ? Yup.object({
          // myValuation: Yup.string().required("My Valuation is required"),
          // myComments: Yup.string().required("My Comments is required"),
        })
      : baseUrlEng === "AuctionCatalog"
      ? Yup.object({
          basePrice: Yup.number()
            .positive("Base price should be greater than zero")
            .typeError("Base Price must be a number")
            .required("Please enter Base Price")
            .test(
              "twoDecimalPlaces",
              "Base Price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            ),
          priceIncrement: Yup.number().required("Please enter Price Increment"),
          gardenCertification: Yup.string().required(
            "Please enter Garden Certification"
          ),
          ageOfProducts: Yup.number().required(
            "Please enter Age of the Tea (In Months)"
          ),
          auctioneerValuation: Yup.number()
            .typeError("Auctioneer's Valuation must be a number")
            .required("Please enter Auctioneer's Valuation")
            .test(
              "twoDecimalPlaces",
              "Auctioneer Valuation cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                // two dasimle value change in resever price auctioner valuaction and also baseprise if chnage in this
                // const decimalPart = value.toString().split(".")[1];
                // return !decimalPart || decimalPart.length <= 2;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            ),
          reservePrice: Yup.number()
            .typeError("Reserve Price must be a number")
            .test(
              "minBasePrice",
              "Reserve Price should always be greater than or equal to Base Price.",
              function (value) {
                const { basePrice } = this.parent;
                return basePrice === undefined || value >= basePrice;
              }
            )
            // .min(
            //   Yup.ref("basePrice"),
            //   "Reserve Price should always be greater than or equal to Base Price."
            // )
            .test(
              "twoDecimalPlaces",
              "Reserve price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .required("Please enter Reserve Price"),
          markPackageComments: Yup.string().max(
            255,
            "Mark & Packaging Comments must be 255 characters or less"
          ),
          lotComments: Yup.string().max(
            255,
            "Lot Comments must be 255 characters or less"
          ),
          grossKgs: Yup.number()
            .required("Please enter Gross Weight")
            .typeError("Gross Weight must be a number")
            .test(
              "twoDecimalPlaces",
              "Gross Weight must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          tareKgs: Yup.number()
            .required("Tare Kgs is required")
            .typeError("Tare KGs must be a number")
            .positive("Tare KGs must be a positive number")
            .test(
              "is-numeric-with-decimal",
              "Positive Numeric with two digits after decimal point Non-zero.",
              function (value) {
                return /^\d+(\.\d{1,2})?$/.test(value);
              }
            )
            .min(0.01, "Tare Kgs must be at least 0.01")
            .lessThan(
              Yup.ref("grossKgs"),
              "Tare KGs must be less than Gross KGs"
            ),
          packageNo: Yup.string().matches(
            /^\d+-\d+$/,
            "Package No. must be in the format X-Y"
          ),
          sampleQty: Yup.number()
            .typeError("Sample Qty. must be a number")
            .test(
              "twoDecimalPlaces",
              "Sample Qty must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          ShortExcessWeight: Yup.number()
            .typeError("Short/Excess Weight must be a number")
            .test(
              "is-numeric-with-decimal",
              "Positive Numeric with two digits after decimal point Non-zero.",
              function (value = 0) {
                return /^\d+(\.\d{1,2})?$/.test(value || 0);
              }
            ),
          // Add validation for other fields here
        })
      : baseUrlEng === "EnglishAuctionCatalog"
      ? Yup.object({
          //sessionTypeName: Yup.string().required("Please select Session Type"),
          basePrice: Yup.number()
            .positive("Base price should be greater than zero")
            .typeError("Base Price must be a number")
            .required("Please enter Base Price")
            .test(
              "twoDecimalPlaces",
              "Base Price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .test(
              "maxBasePrice",
              "Base Price should always be less than or equal to Reserve Price.",
              function (value) {
                const { reservePrice } = this.parent;
                return reservePrice === undefined || value <= reservePrice;
              }
            ),
          // .max(
          //   Yup.ref("reservePrice"),
          //   "Base Price should always be less than or equal to Reserve Price."
          // )
          auctioneerValuation: Yup.number()
            .typeError("Auctioneer's Valuation must be a number")
            .required("Please enter Auctioneer's Valuation")
            .test(
              "twoDecimalPlaces",
              "Auctioneer Valuation cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .test(
              "maxReservePricePrice",
              "Auctioneer's Valuation should always be greater than or equal to Reserve Price.",
              function (value) {
                const { reservePrice } = this.parent;
                return reservePrice === undefined || value >= reservePrice;
              }
            ),
          // .min(
          //   Yup.ref("reservePrice"),
          //   "Auctioneer's Valuation should always be greater than or equal to Reserve Price."
          // )
          reservePrice: Yup.number()
            .typeError("Reserve Price must be a number")
            .test(
              "minBasePrice",
              "Reserve Price should always be greater than or equal to Base Price.",
              function (value) {
                const { basePrice } = this.parent;
                return basePrice === undefined || value >= basePrice;
              }
            )
            // .min(
            //   Yup.ref("basePrice"),
            //   "Reserve Price should always be greater than or equal to Base Price."
            // )
            .test(
              "twoDecimalPlaces",
              "Reserve price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .required("Please enter Reserve Price"),
          markPackageComments: Yup.string().max(
            255,
            "Mark & Packaging Comments must be 255 characters or less"
          ),
          lotComments: Yup.string().max(
            255,
            "Lot Comments must be 255 characters or less"
          ),
          // grossWeight: Yup.number()
          //   .typeError("Gross Weight must be a number")
          //   .test(
          //     "twoDecimalPlaces",
          //     "Gross Weight must have at most two decimal places",
          //     (value) => {
          //       if (typeof value !== "number") return true;
          //       const decimalPart = value.toString().split(".")[1];
          //       return !decimalPart || decimalPart.length <= 2;
          //     }
          //   ),
          grossKgs: Yup.number()
            .required("Please enter Gross Weight")
            .typeError("Gross Weight must be a number")
            .test(
              "twoDecimalPlaces",
              "Gross Weight must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          tareKgs: Yup.number()
            .required("Please enter Tare Weight")
            .typeError("Tare Weight must be a number")
            .test(
              "twoDecimalPlaces",
              "Tare  Weight must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          packageNo: Yup.string()
            .required("Please enter Packege No.")
            .matches(/^\d+-\d+$/, "Package No. must be in the format X-Y"),

          sampleQty: Yup.number()
            .typeError("Sample Qty. must be a number")
            .test(
              "twoDecimalPlaces",
              "Sample Qty must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          // Add validation for other fields here
        })
      : baseUrlEng === "EnglishAuctionKutchaCatalogue"
      ? Yup.object({
          sessionTypeName: Yup.string().required("Please select Session Type"),
          basePrice: Yup.number()
            .positive("Base price should be greater than zero")
            .typeError("Base Price must be a number")
            .required("Please enter Base Price")
            .test(
              "twoDecimalPlaces",
              "Base Price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .test(
              "maxBasePrice",
              "Base Price should always be less than or equal to Reserve Price.",
              function (value) {
                const { reservePrice } = this.parent;
                return reservePrice !== undefined || value <= reservePrice;
              }
            ),
          auctioneerValuation: Yup.number()
            .typeError("Auctioneer's Valuation must be a number")
            .required("Please enter Auctioneer's Valuation")
            .test(
              "twoDecimalPlaces",
              "Auctioneer Valuation cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .test(
              "maxReservePricePrice",
              "Auctioneer's Valuation should always be greater than or equal to Reserve Price.",
              function (value) {
                const { reservePrice } = this.parent;
                return reservePrice === undefined || value >= reservePrice;
              }
            ),
          reservePrice: Yup.number()
            .typeError("Reserve Price must be a number")
            .test(
              "minBasePrice",
              "Reserve Price should always be greater than or equal to Base Price.",
              function (value) {
                const { basePrice } = this.parent;
                return basePrice === undefined || value >= basePrice;
              }
            )
            .test(
              "twoDecimalPlaces",
              "Reserve price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .required("Please enter Reserve Price"),
          markPackageComments: Yup.string().max(
            255,
            "Mark & Packaging Comments must be 255 characters or less"
          ),
          lotComments: Yup.string().max(
            255,
            "Lot Comments must be 255 characters or less"
          ),
          grossKgs: Yup.number()
            .required("Please enter Gross Weight")
            .typeError("Gross Weight must be a number")
            .test(
              "twoDecimalPlaces",
              "Gross Weight must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          tareKgs: Yup.number()
            .typeError("Tare  Weight must be a number")
            .test(
              "twoDecimalPlaces",
              "Tare Weight must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          packageNo: Yup.string().matches(
            /^\d+-\d+$/,
            "Package No. must be in the format X-Y"
          ),

          sampleQty: Yup.number()
            .typeError("Sample Qty. must be a number")
            .test(
              "twoDecimalPlaces",
              "Sample Qty must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          // Add validation for other fields here
        })
      : Yup.object({
          sessionTypeName: Yup.string().required("Please select Session Type"),
          basePrice: Yup.number()
            .positive("Base price should be greater than zero")
            .typeError("Base Price must be a number")
            .required("Please enter Base Price")
            .test(
              "twoDecimalPlaces",
              "Base Price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .max(
              Yup.ref("reservePrice"),
              "Base Price should always be less than or equal to Reserve Price."
            ),
          auctioneerValuation: Yup.number()
            .typeError("Auctioneer's Valuation must be a number")
            .required("Please enter Auctioneer's Valuation")
            .test(
              "twoDecimalPlaces",
              "Auctioneer Valuation cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            ),
          reservePrice: Yup.number()
            .typeError("Reserve Price must be a number")
            .min(
              Yup.ref("basePrice"),
              "Reserve Price should always be greater than or equal to Base Price."
            )
            .test(
              "twoDecimalPlaces",
              "Reserve price cannot have decimal value",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString();
                return !decimalPart.includes(".");
              }
            )
            .required("Please enter Reserve Price"),
          markPackageComments: Yup.string().max(
            255,
            "Mark & Packaging Comments must be 255 characters or less"
          ),
          lotComments: Yup.string().max(
            255,
            "Lot Comments must be 255 characters or less"
          ),
          // grossWeight: Yup.number()
          //   .typeError("Gross Weight must be a number")
          //   .test(
          //     "twoDecimalPlaces",
          //     "Gross Weight must have at most two decimal places",
          //     (value) => {
          //       if (typeof value !== "number") return true;
          //       const decimalPart = value.toString().split(".")[1];
          //       return !decimalPart || decimalPart.length <= 2;
          //     }
          //   ),
          grossKgs: Yup.number()
            .required("Please enter Gross Weight")
            .typeError("Gross Weight must be a number")
            .test(
              "twoDecimalPlaces",
              "Gross Weight must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          tareKgs: Yup.number()
            .typeError("Tare Weight must be a number")
            .test(
              "twoDecimalPlaces",
              "Tare  Weight must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          packageNo: Yup.string().matches(
            /^\d+-\d+$/,
            "Package No. must be in the format X-Y"
          ),

          sampleQty: Yup.number()
            .typeError("Sample Qty. must be a number")
            .test(
              "twoDecimalPlaces",
              "Sample Qty must have at most two decimal places",
              (value) => {
                if (typeof value !== "number") return true;
                const decimalPart = value.toString().split(".")[1];
                return !decimalPart || decimalPart.length <= 2;
              }
            ),
          // Add validation for other fields here
        });

  // const commitChanges = ({ changed }) => {
  //   let changedRows;
  //   if (changed) {
  //      changedRows = myCatalogRows.map((row, index) =>
  //       changed[String(index)] ? { ...row, ...changed[String(index)] } : row
  //     );
  //     // setValidationStatus({ ...validationStatus, ...validate(changed, validationStatus) });
  //   }
  //   setRows(changedRows);
  // };

  const fnSubmitonClick = async (
    values,
    getDataByPrems,
    inputdata,
    MyCatalogId,
    valuationMap,
    index
  ) => {
    //debugger;
    // onSubmit: (values, { resetForm }) => {
    openLoader();
    // Handle form submission, e.g., send data to the server
    // console.log("Form submitted with values:", values);
    // if (getDataByPrems?.at(0).hours_date_difference < 48) {
    // if ((values.myValuation === "" || values.myValuation === null || values.myValuation === undefined)
    //   && (values.groupCode == "-" || values.groupCode === "" || values.groupCode === null || values.groupCode === undefined)
    //   && (values.myComments === "" || values.myComments === null || values.myComments === undefined)) {
    //   CustomToast.error("Please fill atleast one field (My valuation,Group Code,My Comments) among these !");
    //   return false;
    // }
    if (userRole === "buyer") {
      await axiosMain
        .post(
          `/preauction/${auctionCatalogUrl}/AddValuation?role=` +
            userRole +
            "&validateAction=submit&dataFlag=Menual&season=" +
            formik.values.season +
            "&saleNo=" +
            formik.values.saleNo,

          [
            {
              //...values,
              myValuation:
                valuationMap["name"] === "myValuation"
                  ? parseFloat(
                      valuationMap[MyCatalogId] === null ||
                        valuationMap[MyCatalogId] === ""
                        ? 0
                        : valuationMap[MyCatalogId]
                    )
                  : values.myValuation === ""
                  ? 0
                  : values.myValuation,
              groupCode:
                valuationMap["name"] === "groupCode"
                  ? valuationMap[MyCatalogId]
                  : values.groupCode == "-" || values.groupCode === ""
                  ? null
                  : values.groupCode,
              auctionCenterId,
              updatedBy: userId,
              createdBy: userId,

              lotNo: values.lotNo,
              myComments:
                valuationMap["name"] === "myComments"
                  ? valuationMap[MyCatalogId]
                  : values.myComments,
            },
          ]
        )
        .then((res) => {
          if (res.data.statusCode === 204) {
            CustomToast.warning(res.data.message);
          } else if (res.data.statusCode === 200) {
            // fngetmycatalog();
            //debugger;
            const updatedRows = myCatalogRows.map((row) => ({
              ...row,
              [valuationMap.name]:
                valuationMap[row.MyCatalogId] ?? row[valuationMap.name], // Update only matching rows
            }));
            setMyCatalogRows(updatedRows);

            setTimeout(() => {
              // //debugger;
              if (inputRefs.current[index + 1]) {
                inputRefs.current[index + 1].focus();
              }

              if (selectRefs.current[index + 1]) {
                selectRefs.current[index + 1].focus();
              }
            }, 1000);
            // CustomToast.success(res.data.message);
            setOpenUploadUpdateValuation(false);
            // resetgetmycatalog();
            // resetForm();

            // If validation succeeds, update the rows
            // const updatedRows = myCatalogRows.map((row, index) =>
            //   changed[String(index)] ? { ...row, ...changed[String(index)] } : row
            // );
            // setMyCatalogRows(updatedRows);
          } else {
            CustomToast.error(res.data.message);
          }
          setValuationMap({});
          // setEditableCell({ rowId: null, columnName: null });
          closeLoader();
        })
        .catch((error) => {
          // CustomToast.error();
          closeLoader();
        });
    } else {
      if (
        (baseUrlEng === "AuctionCatalog" &&
          getDataByPrems?.at(0)?.minute_difference >= 15 &&
          getDataByPrems?.at(0)?.hours_date_difference < 48) ||
        (baseUrlEng === "EnglishAuctionCatalog" &&
          // getDataByPrems?.at(0)?.minute_difference >= 15 &&
          getDataByPrems?.at(0)?.hours_date_difference < 24) ||
        (baseUrlEng === "EnglishAuctionKutchaCatalogue" &&
          // getDataByPrems?.at(0)?.minute_difference >= 15 &&
          getDataByPrems?.at(0)?.hours_date_difference < 24)
      ) {
        const {
          auctionCatalogId,
          SampleQty,
          basePrice,
          reservePrice,
          auctioneerValuation,
          priceIncrement,
          markPackageComments,
          lotComments,
          qualityComments,
          qualityCertification,
          brewColor,
          ageOfProducts,
          brewersComments,
          gardenCertification,
          netWeight,
          auctioneerId,
          saleNo,
          season,
          grossKgs,
          tareKgs,
        } = values;
        await axiosMain
          .post(
            baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? `/preauction/EnglishAuctionKutchaCatalogue/UpdateKutchaCatalogValuationReservePrice`
              : `/preauction/${baseUrlEng}/UpdateMyCatalogValuationReservePrice?role=` +
                  userRole,
            baseUrlEng === "AuctionCatalog" ||
              baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? {
                  season: formik.values?.season?.toString(),
                  saleNo: parseInt(formik.values?.saleNo),
                  auctionCenterId,
                  KutchaCatalogId: parseInt(
                    getDataByPrems?.at(0)?.KutchaCatalogId
                  ),
                  reservePrice,
                  basePrice,
                  auctioneerId: userId,
                  ageOfProducts: values.ageOfProducts,
                  gardenCertification: values.gardenCertification,
                  SaleProgramId: getDataByPrems[0]?.saleprogramid,
                }
              : {
                  season: formik.values?.season,
                  saleNo: parseInt(formik.values?.saleNo),
                  auctionCenterId,
                  KutchaCatalogId: parseInt(
                    getDataByPrems?.at(0)?.KutchaCatalogId
                  ),
                  reservePrice,
                  auctioneerId: userId,
                  ageOfProducts: values.ageOfProducts,
                  gardenCertification: values.gardenCertification,
                  SaleProgramId: getDataByPrems[0]?.saleprogramid,
                  auctionCatalogId: getDataByPrems[0]?.auctionCatalogId,
                }
          )
          .then((res) => {
            if (res.data.statusCode === 403) {
              CustomToast.warning(res.data.message);
            } else if (res.data.statusCode === 200) {
              // CustomToast.success(res.data.message);
              setOpenUploadUpdateValuation(false);
              // resetForm();
              // if (baseUrlEng === "EnglishAuctionKutchaCatalogue") {
              //   // resetgetkuchacatalog();
              // } else {
              //   // resetgetmycatalog();
              // }
              // If validation succeeds, update the rows
              // const updatedRows = myCatalogRows.map((row, index) =>
              //   changed[String(index)] ? { ...row, ...changed[String(index)] } : row
              // );
              // setMyCatalogRows(updatedRows);
              // fngetmycatalog();
              const updatedRows = myCatalogRows.map((row) => ({
                ...row,
                [valuationMap.name]:
                  valuationMap[row.auctionCatalogId] ?? row[valuationMap.name], // Update only matching rows
              }));
              setMyCatalogRows(updatedRows);

              setTimeout(() => {
                // //debugger;
                if (inputRefs.current[index + 1]) {
                  inputRefs.current[index + 1].focus();
                }
                if (selectRefs.current[index + 1]) {
                  selectRefs.current[index + 1].focus();
                }
              }, 1000);
            } else {
              CustomToast.error(res.data.message);
            }
            setValuationMap({});
            // setEditableCell({ rowId: null, columnName: null });
            closeLoader();
          })
          .catch((error) => {
            // CustomToast.error();
            closeLoader();
          });
      } else {
        values.auctioneerId = getDataByPrems?.at(0)?.auctioneerId;
        const {
          auctionCatalogId,
          SampleQty,
          basePrice,
          reservePrice,
          auctioneerValuation,
          priceIncrement,
          markPackageComments,
          lotComments,
          qualityComments,
          qualityCertification,
          brewColor,
          ageOfProducts,
          brewersComments,
          gardenCertification,
          netWeight,
          auctioneerId,
          grossKgs,
          tareKgs,
          totalPackages,
          packageNo,
          ShortExcessWeight,
          sessionTypeName,
          remarks,
          markName,
        } = values;
        await axiosMain
          .post(
            baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? `/preauction/${baseUrlEng}/UpdateKutchaCatalogueDetails?role=` +
                  userRole +
                  "&flag=" +
                  dataFlag +
                  "&validateAction=submit&season=" +
                  formik.values.season +
                  "&saleNo=" +
                  formik.values.saleNo
              : `/preauction/${baseUrlEng}/UploadValuation?role=` +
                  userRole +
                  "&flag=" +
                  dataFlag +
                  "&validateAction=submit&season=" +
                  formik.values.season +
                  "&saleNo=" +
                  formik.values.saleNo,
            // axios
            //   .post(
            //     "http://192.168.101.221:5080/preauction/AuctionCatalog/UploadValuation?role=" +
            //       userRole,
            // [{
            //   auctionCatalogId: auctionCatalogId,
            //   season: getDataByPrems[0]?.season,
            //   saleNo:
            //     getDataByPrems[0]?.saleNo !== "" ||
            //     getDataByPrems[0]?.saleNo !== 0
            //       ? parseInt(getDataByPrems[0]?.saleNo)
            //       : 0,
            //   SampleQty: SampleQty,
            //   basePrice: basePrice,
            //   reservePrice: reservePrice,
            //   auctioneerValuation: auctioneerValuation,
            //   priceIncrement: priceIncrement,
            //   markPackageComments: markPackageComments,
            //   lotComments: lotComments,
            //   qualityComments: qualityComments,
            //   qualityCertification: qualityCertification,
            //   brewColor: brewColor,
            //   ageOfProducts: ageOfProducts,
            //   brewersComments: brewersComments,
            //   gardenCertification: gardenCertification,
            //   netWeight: netWeight,
            //   auctioneerId: userId, //auctioner
            // }][
            baseUrlEng === "EnglishAuctionKutchaCatalogue"
              ? [
                  {
                    KutchaCatalogId: getDataByPrems?.at(0)?.KutchaCatalogId,
                    invoiceId: getDataByPrems?.at(0)?.invoiceId,
                    saleNo: getDataByPrems?.at(0)?.saleNo,
                    locationInsideWarehouse:
                      getDataByPrems?.at(0)?.locationInsideWarehouse,
                    remarks: remarks, //getDataByPrems?.at(0)?.remarks,

                    // ageOfProducts:
                    //   ageOfProducts === undefined ? null : ageOfProducts,
                    auctioneerValuation:
                      auctioneerValuation === undefined
                        ? null
                        : auctioneerValuation,
                    basePrice: basePrice === undefined ? null : basePrice,
                    // brewersComments:
                    //   brewersComments === undefined ? null : brewersComments,
                    // brewColor: brewColor === undefined ? null : brewColor,
                    // gardenCertification:
                    //   gardenCertification === undefined
                    //     ? null
                    //     : gardenCertification,
                    lotComments: lotComments === undefined ? null : lotComments,
                    LotNo: getDataByPrems?.at(0)?.LotNo,
                    markPackageComments:
                      markPackageComments === undefined
                        ? null
                        : markPackageComments,
                    priceIncrement:
                      priceIncrement === undefined ||
                      priceIncrement === "" ||
                      priceIncrement === null
                        ? 1
                        : priceIncrement,
                    // // qualityCertification:
                    // //   qualityCertification === undefined
                    // //     ? null
                    // //     : qualityCertification,
                    qualityComments:
                      qualityComments === undefined ? null : qualityComments,
                    reservePrice: parseFloat(reservePrice),
                    SampleQty: SampleQty,
                    sessionTypeName: sessionTypeName,
                    // createdOn: null,
                    createdBy: userId, //auctioner
                    updatedBy: userId, //auctioner
                    // updatedOn: null,
                    status: 1,
                    auctionCenterId: auctionCenterId,
                    saleprogramid: saleProgramId?.at(0)?.SaleProgramId,

                    auctioneerId: userId,
                    auctionTypeMasterId: 2,
                    // markPackageComments,
                    // lotComments,
                    grossKgs,
                    tareKgs,
                    //new added
                    packageNo: values.packageNo, // getDataByPrems?.at(0)?.packageNo,
                    totalPackages: values.totalPackages, // getDataByPrems?.at(0)?.totalPackages,
                  },
                ]
              : baseUrlEng === "AuctionCatalog"
              ? [
                  {
                    KutchaCatalogId: getDataByPrems?.at(0)?.KutchaCatalogId,
                    invoiceId: getDataByPrems?.at(0)?.invoiceId,
                    ageOfProducts:
                      ageOfProducts === undefined ? null : ageOfProducts,
                    auctioneerValuation:
                      auctioneerValuation === undefined
                        ? null
                        : auctioneerValuation,
                    basePrice: basePrice === undefined ? null : basePrice,
                    brewersComments:
                      brewersComments === undefined ? null : brewersComments,
                    brewColor: brewColor === undefined ? null : brewColor,
                    gardenCertification:
                      gardenCertification === undefined
                        ? null
                        : gardenCertification,
                    lotComments: lotComments === undefined ? null : lotComments,
                    LotNo: getDataByPrems?.at(0)?.LotNo,
                    markPackageComments:
                      markPackageComments === undefined
                        ? null
                        : markPackageComments,
                    priceIncrement:
                      priceIncrement === undefined ? null : priceIncrement,
                    qualityCertification:
                      qualityCertification === undefined
                        ? null
                        : qualityCertification,
                    qualityComments:
                      qualityComments === undefined ? null : qualityComments,
                    reservePrice: parseFloat(reservePrice),
                    SampleQty: SampleQty,
                    sessionType: getDataByPrems?.at(0)?.sessionType,
                    createdOn: null,
                    createdBy: userId, //auctioner
                    updatedBy: userId, //auctioner
                    updatedOn: null,
                    status: 1,
                    auctionCenterId: auctionCenterId,
                    saleprogramid: getDataByPrems?.at(0)?.saleprogramid,
                    grossKgs,
                    tareKgs,
                    packageNo,
                    totalPackages,
                    ShortExcessWeight: ShortExcessWeight || 0,
                  },
                ]
              : [
                  {
                    sessionType: getDataByPrems?.at(0)?.sessionType,
                    KutchaCatalogId: getDataByPrems?.at(0)?.KutchaCatalogId,
                    invoiceId: getDataByPrems?.at(0)?.invoiceId,
                    saleNo: getDataByPrems?.at(0)?.saleNo,
                    locationInsideWarehouse:
                      getDataByPrems?.at(0)?.locationInsideWarehouse,
                    remarks: getDataByPrems?.at(0)?.remarks,
                    markId: markDataList
                      ?.filter((ele) => ele.markCode === markName)
                      ?.at(0)?.markId,
                    // ageOfProducts:
                    //   ageOfProducts === undefined ? null : ageOfProducts,
                    auctioneerValuation:
                      auctioneerValuation === undefined
                        ? null
                        : auctioneerValuation,
                    basePrice: basePrice === undefined ? null : basePrice,
                    // brewersComments:
                    //   brewersComments === undefined ? null : brewersComments,
                    // brewColor: brewColor === undefined ? null : brewColor,
                    // gardenCertification:
                    //   gardenCertification === undefined
                    //     ? null
                    //     : gardenCertification,
                    lotComments: lotComments === undefined ? null : lotComments,
                    LotNo: getDataByPrems?.at(0)?.LotNo,
                    markPackageComments:
                      markPackageComments === undefined
                        ? null
                        : markPackageComments,
                    priceIncrement:
                      priceIncrement === undefined ? null : priceIncrement,
                    // // qualityCertification:
                    // //   qualityCertification === undefined
                    // //     ? null
                    // //     : qualityCertification,
                    qualityComments:
                      qualityComments === undefined ? null : qualityComments,
                    reservePrice: parseFloat(reservePrice),
                    SampleQty: SampleQty,
                    // sessionTypeName: getDataByPrems?.at(0)?.sessionType,
                    createdOn: null,
                    createdBy: userId, //auctioner
                    updatedBy: userId, //auctioner
                    updatedOn: null,
                    status: 1,
                    auctionCenterId: auctionCenterId,
                    saleprogramid: getDataByPrems?.at(0)?.saleprogramid,

                    auctioneerId: userId,
                    auctionTypeMasterId: 2,
                    // markPackageComments,
                    // lotComments,
                    grossKgs,
                    tareKgs,
                    //new added
                    // packageNo: getDataByPrems?.at(0)?.packageNo,
                    // totalPackages: getDataByPrems?.at(0)?.totalPackages,
                    packageNo: values.packageNo, // getDataByPrems?.at(0)?.packageNo,
                    totalPackages: values.totalPackages, // getDataByPrems?.at(0)?.totalPackages,
                  },
                ]
          )
          .then((res) => {
            if (res.data.statusCode === 204) {
              CustomToast.warning(res.data.message);
            } else if (
              res.data.statusCode === 422 &&
              (baseUrlEng === "EnglishAuctionCatalog" ||
                baseUrlEng === "EnglishAuctionKutchaCatalogue")
            ) {
              // CustomToast.warning(response.data.message);
              setDataFlag(true);
              setOpenModalConformation(true);
              setOpenModalConformationTitle(res.data.message);
            } else if (res.data.statusCode === 200) {
              setOpenModalConformation(false);
              setDataFlag(false);
              // CustomToast.success(res.data.message);
              setOpenUploadUpdateValuation(false);
              // resetForm();
              // if (baseUrlEng === "EnglishAuctionKutchaCatalogue") {
              //   // resetgetkuchacatalog();
              // } else {
              //   // resetgetmycatalog();
              // }
              // If validation succeeds, update the rows
              // const updatedRows = myCatalogRows.map((row, index) =>
              //   changed[String(index)] ? { ...row, ...changed[String(index)] } : row
              // );
              // setMyCatalogRows(updatedRows);
              // fngetmycatalog();
              const updatedRows = myCatalogRows.map((row) => ({
                ...row,
                [valuationMap.name]:
                  valuationMap[row.auctionCatalogId] ?? row[valuationMap.name], // Update only matching rows
              }));
              setMyCatalogRows(updatedRows);

              setTimeout(() => {
                // //debugger;
                if (inputRefs.current[index + 1]) {
                  inputRefs.current[index + 1].focus();
                }
                if (selectRefs.current[index + 1]) {
                  selectRefs.current[index + 1].focus();
                }
              }, 1000);
            } else if (res.data.statusCode === 403) {
              CustomToast.warning(res.data.message);
            } else {
              CustomToast.error(res.data.message);
            }
            setValuationMap({});
            // setEditableCell({ rowId: null, columnName: null });
            closeLoader();
          })
          .catch((error) => {
            // CustomToast.error();
            closeLoader();
          });
      }
    }
    // },
    closeLoader();
  };
  // const commitChanges = ({ changed }) => {
  //   if (!changed) return;

  //   const changedIndex = Object.keys(changed)[0]; // Get the first changed row index
  //   const updatedRow = { ...myCatalogRows[changedIndex], ...changed[changedIndex] };

  //   validationSchema
  //     .validate(updatedRow, { abortEarly: false })
  //     .then(() => {
  //       handleCellClick(updatedRow);
  //       fnSubmitonClick(updatedRow);
  //       // If validation succeeds, update the rows
  //       const updatedRows = myCatalogRows.map((row, index) =>
  //         changed[String(index)] ? { ...row, ...changed[String(index)] } : row
  //       );
  //       setMyCatalogRows(updatedRows);
  //     })
  //     .catch((validationErrors) => {
  //       CustomToast.error(validationErrors.inner?.at(0).errors?.at(0));
  //       // console.error("Validation errors:", validationErrors.inner);
  //       // Handle validation errors (e.g., show in UI)
  //     });
  // };
  const commitChanges = async (row, inputdata, MyCatalogId, colName, index) => {
    // if (!changed) return;
    // if (changed["0"] === undefined) return;

    // setchanged(changed);

    // const changedIndex = Object.keys(changed)[0]; // Get the first changed row index
    // const updatedRow = { ...myCatalogRows[changedIndex], ...changed[changedIndex] };

    const updatedRow = { ...row, [colName]: inputdata };
    try {
      // await setValuationMap({
      //   [MyCatalogId]: inputdata,
      //   name: colName
      // });
      await validationSchema.validate(updatedRow, { abortEarly: false });

      let clickdata = await handleCellClick(updatedRow);
      await fnSubmitonClick(
        updatedRow,
        clickdata,
        inputdata,
        MyCatalogId,
        {
          [MyCatalogId]: inputdata,
          name: colName,
        },
        index
      );
    } catch (validationErrors) {
      CustomToast.error(validationErrors.inner?.at(0).errors?.at(0));
      // console.error("Validation errors:", validationErrors.inner);
      // Handle validation errors (e.g., show in UI)
    }
  };

  const formik = useFormik({
    initialValues:
      // auctionCatalogUrl === "EnglishAuctionBuyer"
      {
        season: new Date().getFullYear()?.toString(),
        saleNo: 0,
        auctionDate: "",
        // auctioneer: "",
        auctioneerId: 0,
        teaType: 0,
        category: 0,
        sessionTime: "",
        mark: 0,
        grade: 0,
        origin: "",
      },
    // : {
    //   season: new Date().getFullYear()?.toString(),
    //   saleNo: 0,
    //   auctionDate: "",
    //   // auctioneer: "",
    //   auctioneerId: 0,
    //   teaType: 0,
    //   category: 0,
    //   sessionTime: "",
    // }
    onSubmit: (values) => {
      console.log(
        "🚀 ~ file: AuctionCatalogform.jsx:47 ~ AuctionCatalog ~ values:",
        values
      );
      // This function will be called when the form is submitted
      // console.log("Form data submitted:", values);

      // let data = {
      //   season: values.season,
      //   saleNo: values.saleNo,
      //   auctionDate: values.auctionDate,
      //   auctioneerId: values.auctioneer,
      //   teaTypeId: values.teaType,
      //   categoryId: values.category,
      //   sessionStartTime: values.sessionTime,
      //   sessionEndTime: values.sessionTime,
      // };
      // let data = [...sessionTime];

      // console.log([...sessionTime, values], values, "sessionTime");
      openLoader();
      const {
        season,
        saleNo,
        auctionDate,
        auctioneerId,
        teaType,
        category,
        sessionTime,
        grade,
      } = values;
      //SDP
      // const updatedObject = { ...values, auctionCenterId: auctionCenterId };
      const updatedObject = {
        season: season,
        saleNo: parseInt(saleNo),
        auctionDate: auctionDate,
        auctionCenterId: parseInt(auctionCenterId),
        auctioneerId: parseInt(auctioneerId),
        teaTypeId:
          teatypeList.filter((ele) => ele.teaTypeId === parseInt(teaType))[0]
            ?.teaTypeName === "BOTH"
            ? 0
            : parseInt(teaType),
        categoryId:
          category !== "" && category !== undefined ? parseInt(category) : 0,
        gradeId: grade !== "" && grade !== undefined ? parseInt(grade) : 0,
        sessionStartTime:
          sessionTime?.split(" - ") !== undefined && sessionTime != ""
            ? sessionTime?.split(" - ")?.at(0)
            : "",
        sessionEndTime:
          sessionTime?.split(" - ") !== undefined && sessionTime != ""
            ? sessionTime?.split(" - ")?.at(1)
            : "",
      };
      if (userRole === "auctioneer") {
        axiosMain
          .post(
            `/preauction/${auctionCatalogUrl}/GetAuctionCatalog`,
            updatedObject
          )
          .then((res) => {
            if (res.data.statusCode === 200) {
              CustomToast.success(res.data.message);
              let data = res.data?.responseData?.map((ele) => {
                return {
                  ...ele,
                  gpDate: formatDateToDdMmYy(ele.gpDate),
                };
              });
              setRows(data);
            } else {
              setRows([]);
              CustomToast.error(res.data.message);
            }
            closeLoader();
          })
          .catch((e) => {
            console.log(e);
            closeLoader();
          });
      } else {
        axiosMain
          .post(
            `/preauction/${auctionCatalogUrl}/GetBuyerAuctionCatalog`,
            updatedObject
          )
          .then((res) => {
            if (res.data.statusCode === 200) {
              setSelectedDataAuctionCatalogdata([]);
              CustomToast.success(res.data.message);
              let data = res.data?.responseData?.map((ele) => {
                return {
                  ...ele,
                  gpDate: formatDateToDdMmYy(ele.gpDate),
                };
              });
              setRows(data);
              setSelectedData([]);
              setSelectedDataMyCatalogdata([]);
              setSelectedRows([]);
            } else {
              setRows([]);
              CustomToast.error(res.data.message);
            }
            closeLoader();
          })
          .catch((error) => {
            if (error.response && error.response.status === 400) {
              // Handle the error and set the error message
              const errorData = error.response.data;
              console.log(
                "🚀 ~ file: AuctionCatalogform.jsx:126 ~ AuctionCatalog ~ errorData:",
                errorData
              );
            }
            closeLoader();
          });
      }
    },
  });

  const [editingRowIds, setEditingRowIds] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [validationStatus, setValidationStatus] = useState({});
  useEffect(() => {
    axiosMain
      .post(
        "/preauction/Common/BindGroupMasterByBuyerUserId?buyerUserId=" + userId,
        {}
      )
      .then((res) => {
        if (res.data.message) {
          setGroupCode(res.data.responseData);
        } else {
          setGroupCode([]);
        }
      });

    const handleClickOutside = (event) => {
      if (isDropdownOpen.current) {
        return; // Skip if dropdown is being interacted with
      }
      if (tableRef.current && !tableRef.current.contains(event.target)) {
        //debugger;
        setEditableCell({ rowId: null, columnName: null });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    dispatch(fetchSaleNumbersRequest(formik.values.season.toString()));
  }, [formik.values.season]);

  useEffect(() => {
    // console.log(formik.values.warehouse, "formik.values.warehouse");
    axiosMain
      .post(`/admin/mark/getOrigin`, {
        markId: parseInt(formik.values.mark),
        auctionCenterId,
      })
      .then((response) => {
        setOriginDataList(response.data.responseData);
        formik.setFieldValue(
          "origin",
          response.data.responseData?.at(0)?.originCode
        );
      })
      .catch((err) => console.log(err));
  }, [formik.values.mark]);

  useEffect(() => {
    // setRows(sellPrograms);
    dispatch(fetchSaleNumbersRequest(formik.values.season));
    // dispatch(teaTypeAction());

    // axiosMain
    //   .post("/preauction/Common/BindAuctioneer")
    //   .then((response) => {
    //     // Handle the API response here
    //     setAuctioneer(response.data.responseData);
    //   })
    //   .catch((error) => {
    //     // Handle errors here
    //   });
    setLoggedUser(JSON.parse(localStorage.getItem("User")));
    dispatch(fetchMarkRequest({ auctionCenterId }));
    dispatch(fetchGradeRequest({ auctionCenterId }));
    axiosMain
      .post(`/admin/mark/getOrigin`, {
        markId: parseInt(formik.values.mark),
        auctionCenterId,
      })
      .then((response) => {
        setOriginDataList(response.data.responseData);
      })
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    setMarkDataList(markList);
    setGradesList(grades);
  }, [markList, grades]);
  useEffect(() => {
    // setRows(sellPrograms);
    if (saleNumber?.length > 0) {
      setSaleNo(saleNumber);
      formik.values.saleNo = saleNumber?.at(0)?.saleNo;
      // formik.values.saleNo = 0;
    } else {
      setSaleNo([]);
    }

    // if (teaType?.length > 0) {
    //   setTeaType(teaType);
    // } else {
    //   setTeaType([]);
    // }
  }, [saleNumber, teaType]);

  useEffect(() => {
    setRows([]);
    setMyCatalogRows([]);
    if (parseInt(formik.values.saleNo) > 0) {
      axiosMain
        .post("/preauction/Common/GetSaleProgramDetailBySaleNo", {
          season: formik.values.season,
          saleNo: parseInt(formik.values.saleNo),
          auctionCenterId: auctionCenterId,
        })
        .then((res) => {
          setSaleProgramId(res.data.responseData[0].SaleProgramId);
          setBaseUrlEng(
            res?.data?.responseData[0]?.auctionTypeCode === "BHARAT"
              ? "AuctionCatalog"
              : "EnglishAuctionCatalog"
          );
          setBaseUrlEngBuyer(
            res?.data?.responseData[0]?.auctionTypeCode === "BHARAT"
              ? "Buyer"
              : "EnglishAuctionBuyer"
          );
        })
        .catch((err) => console.log(err));
      axiosMain
        .post("/preauction/Common/BindAuctionDate", {
          season: formik.values.season,
          saleNo: parseInt(formik.values.saleNo),
          auctionCenterId: auctionCenterId,
        })
        .then((res) => {
          if (res.data.responseData?.length > 0) {
            const dates = res.data.responseData?.map((ele) => {
              return { saleDate: ele?.saleDate?.split("T")?.at(0) };
            });
            // console.log(dates, "444");
            formik.setFieldValue("auctionDate", dates?.at(0)?.saleDate);
            setAuctionDates(dates);
          } else {
            setAuctionDates([]);
          }
        });
      axiosMain
        .post("/preauction/Common/BindAuctioneerByInvoice", {
          season: formik.values.season,
          saleNo: parseInt(formik.values.saleNo),
          auctionCenterId: auctionCenterId,
        })
        .then((res) => {
          if (res.data.responseData?.length > 0) {
            // formik.setFieldValue(
            //   "auctioneer",
            //   res.data.responseData?.at(0)?.userId
            // );
            setAuctioneer(res.data.responseData);
          } else {
            setAuctioneer([]);
          }
        });
      axiosMain
        // .post("/preauction/Common/BindTeaTypeBySeasonSaleNo", {
        .post("/preauction/Common/BindTeaTypeByParam", {
          season: formik.values.season,
          saleNo: parseInt(formik.values.saleNo),
          auctionCenterId: auctionCenterId,
          auctioneerId:
            formik.values.auctioneerId == null ||
            formik.values.auctioneerId === undefined
              ? 0
              : parseInt(formik.values.auctioneerId),
          roleCode
        })
        .then((res) => {
          if (res.data.responseData?.length > 0) {
            // formik.setFieldValue(
            //   "teaType",
            //   res.data.responseData?.at(0)?.teaTypeId
            // );
            setTeaType(res.data.responseData);
          } else {
            setTeaType([]);
          }
        });
      axiosMain
        .post("/preauction/Common/BindCatagoryByParam", {
          season: formik.values.season,
          saleNo: parseInt(formik.values.saleNo),
          // AuctioneerId: parseInt(formik.values.auctioneer),
          auctionCenterId: auctionCenterId,
          auctioneerId:
            formik.values.auctioneerId == null ||
            formik.values.auctioneerId === undefined
              ? 0
              : parseInt(formik.values.auctioneerId),
        })
        .then((res) => {
          if (res?.data?.responseData?.length > 0) {
            // formik.setFieldValue(
            //   "category",
            //   res.data.responseData?.at(0)?.categoryId
            // );
            setCategory(res.data.responseData);
          } else {
            setCategory([]);
          }
        });
    } else {
      setAuctioneer([]);
      setAuctionDates([]);
      setTeaType([]);
    }
  }, [formik.values.saleNo]);

  useEffect(() => {
    // console.log(formik.values.auctioneerId);
    if (auctioneer.length > 0 && parseInt(formik.values.auctioneerId) > 0) {
      axiosMain
        // .post("/preauction/Common/BindTeaTypeBySeasonSaleNo", {
        .post("/preauction/Common/BindTeaTypeByParam", {
          season: formik.values.season,
          saleNo: parseInt(formik.values.saleNo),
          auctionCenterId: auctionCenterId,
          auctioneerId:
            formik.values.auctioneerId == null ||
            formik.values.auctioneerId === undefined
              ? 0
              : parseInt(formik.values.auctioneerId),
            roleCode
        })
        .then((res) => {
          if (res.data.responseData?.length > 0) {
            // formik.setFieldValue(
            //   "teaType",
            //   res.data.responseData?.at(0)?.teaTypeId
            // );
            setTeaType(res.data.responseData);
          } else {
            setTeaType([]);
          }
        });

      axiosMain
        .post("/preauction/Common/BindCatagoryByParam", {
          season: formik.values.season,
          saleNo: parseInt(formik.values.saleNo),
          // AuctioneerId: parseInt(formik.values.auctioneer),
          auctionCenterId: auctionCenterId,
          auctioneerId: parseInt(formik.values.auctioneerId),
        })
        .then((res) => {
          if (res?.data?.responseData?.length > 0) {
            // formik.setFieldValue(
            //   "category",
            //   res.data.responseData?.at(0)?.categoryId
            // );
            setCategory(res.data.responseData);
          } else {
            setCategory([]);
          }
        });
    } else {
      setCategory([]);
    }
  }, [formik.values.auctioneerId]);

  useEffect(() => {
    if (parseInt(formik.values.auctionDate) > 0) {
      // axiosMain
      //   .post(`/preauction/AuctionSession/GetTeaTypeByParam`, {
      //     season: formik.values.season,
      //     saleNo: parseInt(formik.values.saleNo),
      //     auctionCenterId: auctionCenterId,
      //     saleDate: formik.values.auctionDate,
      //   })
      //   .then((res) => {
      //     if (res.data.responseData?.length > 0) {
      //       formik.setFieldValue(
      //         "teaType",
      //         res.data.responseData?.at(0)?.teaTypeId
      //       );
      //       setTeaType(res.data.responseData);
      //     } else {
      //       setTeaType([]);
      //     }
      //   });

      axiosMain
        .post("/preauction/Common/BindSessionTime", {
          season: formik.values.season,
          saleNo: parseInt(formik.values.saleNo),
          auctionDate: formik.values.auctionDate,
          auctionCenterId: auctionCenterId,
          // sessionTypeId: 1,
          auctioneerId: parseInt(formik.values.auctioneerId),
          sessionTypeName:
            auctionCatalogUrl === "EnglishAuctionCatalog" ||
            auctionCatalogUrl === "EnglishAuctionBuyer"
              ? "All"
              : "Normal",
        })
        .then((res) => {
          if (res.data.responseData?.length > 0) {
            // formik.setFieldValue(
            //   "sessionTime",
            //   res.data.responseData?.at(0)?.sessionTime
            // );
            formik.setFieldValue(
              "sessionStartTime",
              res.data.responseData?.at(0)?.sessionTime?.split("-")?.at(0)
            );
            formik.setFieldValue(
              "sessionEndTime",
              res.data.responseData?.at(0)?.sessionTime?.split("-")[1]
            );
            // console.log(
            //   res.data.responseData?.at(0)?.sessionTime,
            //   "sessionTime"
            // );
            setSessionTime(res.data.responseData);
          } else {
            setSessionTime([]);
          }
          // formik.setFieldValue("sessionTime", ""); chenged by piyus s
          // formik.setFieldValue(
          //   "sessionTime",
          //   res.data.responseData?.at(0)?.SessionTime
          // );
        });
    }
    // formik.setFieldValue("");
  }, [formik.values.auctionDate, formik.values.auctioneerId]);

  // useEffect(() => {
  //   if (teatypeList?.length > 0 && parseInt(formik.values.teaType)) {

  //   } else {
  //   }
  // }, [teatypeList, formik.values.teaType]);

  function generateYearOptions() {
    const currentYear = new Date().getFullYear();
    const options = [];

    for (let i = currentYear; i > currentYear - 7; i--) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }

    return options;
  }

  const handleCheckboxChange = (row) => {
    // Check if the row is already in the selectedData array
    const isRowSelected = selectedData.some(
      (selectedRow) => selectedRow.KutchaCatalogId === row.KutchaCatalogId
    );

    if (isRowSelected) {
      // If the row is already selected, remove it from selectedData
      const updatedData = selectedData.filter(
        (selectedRow) => selectedRow.KutchaCatalogId !== row.KutchaCatalogId
      );
      setSelectedData(updatedData);
    } else {
      // If the row is not selected, add it to selectedData
      setSelectedData([...selectedData, row]);
    }
  };

  const handleCheckboxChangeMyCatalog = (row) => {
    // Check if the row is already in the selectedData array
    const isRowSelected = selectedDataMyCatalogdata.some(
      (selectedRow) => selectedRow.MyCatalogId === row.MyCatalogId
    );

    if (isRowSelected) {
      // If the row is already selected, remove it from selectedData
      const updatedData = selectedDataMyCatalogdata.filter(
        (selectedRow) => selectedRow.MyCatalogId !== row.MyCatalogId
      );
      setSelectedDataMyCatalogdata(updatedData);
    } else {
      // If the row is not selected, add it to selectedData
      setSelectedDataMyCatalogdata([...selectedDataMyCatalogdata, row]);
    }
  };
  const myCatalogCloumns =
    baseUrlEng === "AuctionCatalog"
      ? [
          // { title: "Season", name: "season" },
          // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
          { title: "Mark", name: "Mark", noneditable: true, type: "text" },
          {
            title: "Lot No",
            name: "LotNo",
            noneditable: true,
            type: "text",
          },
          {
            title: "Base Price",
            name: "basePrice",
            noneditable: false,
            type: "number",
          },
          {
            title: "Reserve Price",
            name: "reservePrice",
            noneditable: false,
            type: "number",
          },
          {
            title: "Auctioneer's Valuation",
            name: "auctioneerValuation",
            noneditable: false,
            type: "number",
          },
          {
            title: "Mark & Packaging Comments",
            name: "markPackageComments",
            noneditable: false,
            type: "text",
          },
          {
            title: "Lot Comments",
            name: "lotComments",
            noneditable: false,
            type: "text",
          },
          {
            title: "Gross Weight",
            name: "grossKgs",
            noneditable: false,
            type: "number",
          },
          {
            title: "Package No.",
            name: "packageNo",
            noneditable: true,
            type: "text",
          },
          // { title: "Tare Weight", name: "tareKgs" },
          // { title: "Net Weight", name: "netKgs" },
          {
            title: "Sample Qty. (KGs)",
            name: "SampleQty",
            noneditable: false,
            type: "number",
          },
          {
            title: "Quality Comments",
            name: "qualityComments",
            noneditable: false,
            type: "text",
          },
          // { title: "Invoice Weight", name: "invoiceQty",noneditable:false },
          // { title: "GP No.", name: "gpNo",noneditable:false },
          // { title: "GP Date", name: "gpDate",noneditable:false },
          // { title: "Period Of Manufacture (From to To)", name: "periodOfManufacture",noneditable:false },
          {
            title: "Price Increment",
            name: "priceIncrement",
            noneditable: false,
            type: "number",
          },
          // { title: "Market Type", name: "marketTypeName",noneditable:false },
          // { title: "Package Type", name: "packageType",noneditable:false },
          // { title: "Warehouse Name", name: "wareHouseName",noneditable:false },
          {
            title: "Garden Certification",
            name: "gardenCertification",
            noneditable: false,
            type: "text",
          },
          {
            title: "Quality Certification",
            name: "qualityCertification",
            noneditable: false,
            type: "text",
          },
          {
            title: "Age of the Tea (In Months)",
            name: "ageOfProducts",
            noneditable: false,
            type: "number",
          },
          {
            title: "Color of Brew",
            name: "brewColor",
            noneditable: false,
            type: "text",
          },
          // { title: "Age of Products (In Months)", name: "ageOfProducts",noneditable:false },
          {
            title: "Brewers Comments",
            name: "brewersComments",
            noneditable: false,
            type: "text",
          },

          { title: "LSP / SP", name: "LSP_SP", noneditable: true },
          { title: "System Base Price", name: "SBP", noneditable: true },
        ]
      : [
          // { title: "Season", name: "season" },
          // { title: "Sale No.", name: "saleNo", noneditable: true, type: "number" },
          // { title: "Mark", name: "markName", noneditable: true, type: "text" },
          {
            title: "Lot No",
            name: "LotNo",
            noneditable: true,
            type: "text",
          },
          {
            title: "Mark",
            name: "markName",
            noneditable: true,
            type: "text",
          },
          {
            title: "Base Price",
            name: "basePrice",
            noneditable: false,
            type: "number",
          },
          {
            title: "Reserve Price",
            name: "reservePrice",
            noneditable: false,
            type: "number",
          },
          {
            title: "Auctioneer's Valuation",
            name: "auctioneerValuation",
            noneditable: false,
            type: "number",
          },

          {
            title: "Session Type",
            name: "sessionTypeName",
            noneditable: true,
            type: "select",
          },
          {
            title: "Mark & Packaging Comments",
            name: "markPackageComments",
            noneditable: false,
            type: "text",
          },
          {
            title: "Lot Comments",
            name: "lotComments",
            noneditable: false,
            type: "text",
          },
          {
            title: "Gross Weight",
            name: "grossKgs",
            noneditable: false,
            type: "number",
          },
          {
            title: "Tare Weight",
            name: "tareKgs",
            noneditable: false,
            type: "number",
          },
          {
            title: "Category",
            name: "categoryName",
            noneditable: true,
            type: "text",
          },
          {
            title: "Package No.",
            name: "packageNo",
            noneditable: false,
            type: "text",
          },

          {
            title: "Sample Qty. (KGs)",
            name: "SampleQty",
            noneditable: false,
            type: "number",
          },
          {
            title: "Total Package",
            name: "totalPackages",
            noneditable: false,
            type: "number",
          },
          {
            title: "Quality Comments",
            name: "qualityComments",
            noneditable: false,
            type: "text",
          },
          {
            title: "Short Excess Weight",
            name: "shortExcessWeight",
            noneditable: true,
            type: "text",
          },
        ];
  const sellProgramsForBuyer =
    auctionCatalogUrl !== "EnglishAuctionBuyer"
      ? [
          // {
          //   title: ,
          //   name: ".",
          //   getCellValue: ({ ...row }) => (
          //     <>
          //       <input
          //         type="checkbox"
          //         checked={selectedData.some(
          //           (selectedRow) =>
          //             selectedRow.KutchaCatalogId === row.KutchaCatalogId
          //         )}
          //         onChange={() => handleCheckboxChange(row)}
          //       />
          //     </>
          //   ),
          // },

          { title: "Lot No.", name: "LotNo" },
          { title: "Origin", name: "Origin" },
          { title: "Tea Type", name: "teaTypeName" },
          { title: "Sub Type", name: "subTeaTypeName" },
          { title: "Category", name: "categoryName" },
          { title: "Mark", name: "markName" },
          { title: "Grade", name: "gradeName" },
          { title: "No. of Packages", name: "totalPackages" },
          { title: "Gross Weight", name: "grossKgs" },
          { title: "Net Weight", name: "netKgs" },
          { title: "Sample Qty. (KGs)", name: "SampleQty" },
          { title: "Invoice Weight", name: "invoiceQty" },
          {
            title: "Period of Manufacture (From to To) (From to To)",
            name: "periodOfManufacture",
            // getCellValue: ({ ...row }) =>
            //   newformatDateToDdMmYy(row.periodOfManufacture.split("to")[1]),
          },
          { title: "Base Price", name: "basePrice" },
          { title: "Price Increment", name: "priceIncrement" },
          { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
          // { title: "LSP / SP", name: "LSP_SP" },
          { title: "Mark & Packaging Comments", name: "markPackageComments" },
          { title: "Lot Comments", name: "lotComments" },
          { title: "Market Type (Lot Type)", name: "marketTypeName" },
          { title: "GP No.", name: "gpNo" },
          { title: "GP Date", name: "gpDate" },
          { title: "Invoice No.", name: "invoiceNo" },
          { title: "Package Type", name: "packageType" },
          { title: "Package No.", name: "packageNo" },
          { title: "Warehouse Unit Code", name: "wareHouseName" },
          { title: "Garden Certification", name: "gardenCertification" },
          { title: "Quality Certification", name: "qualityCertification" },
          { title: "Color of Brew", name: "brewColor" },
          { title: "Age of Products (In Months)", name: "ageOfProducts" },
          { title: "Brewers Comments", name: "brewersComments" },
          // { title: "Reserve Price", name: "reservePrice" },
          // { title: "LSP / SP", name: "LSP_SP" },
          // { title: "Quality Comments", name: "qualityComments" },

          // { title: "Tare Weight", name: "tareKgs" },
          // { title: "Short accses Weight", name: "shortAccsesWeight" },

          // { title: "System Base Price", name: "SystemBasePrice" },
          // { title: "SBP_LSP/SP", name: "SBP_LSP_SP" },
        ]
      : [
          { title: "Lot No.", name: "LotNo" },
          { title: "Origin", name: "Origin" },
          { title: "Tea Type", name: "teaTypeName" },
          { title: "Sub Type", name: "subTeaTypeName" },
          { title: "Category", name: "categoryName" },
          { title: "Mark", name: "markName" },
          { title: "Grade", name: "gradeName" },
          { title: "No. of Packages", name: "totalPackages" },
          { title: "Gross Weight", name: "grossKgs" },
          { title: "Net Weight", name: "netKgs" },
          { title: "Sample Qty. (KGs)", name: "SampleQty" },
          { title: "Invoice Weight", name: "invoiceQty" },
          {
            title: "Period of Manufacture (From to To)",
            name: "periodOfManufacture",
          },
          { title: "Base Price", name: "basePrice" },
          // { title: "Price Increment", name: "priceIncrement" },
          { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
          { title: "LSP/SP", name: "LSP_SP" },
          { title: "Mark & Packaging Comments", name: "markPackageComments" },
          { title: "Lot Comments", name: "lotComments" },
          { title: "Market Type (Lot Type)", name: "lotType" },
          { title: "GP No.", name: "gpNo" },
          { title: "GP Date", name: "gpDate" },
          { title: "Invoice No.", name: "invoiceNo" },
          { title: "Package Type", name: "packageType" },
          { title: "Package No.", name: "packageNo" },
          { title: "Warehouse Unit Code", name: "wareHouseName" },
          // { title: "Garden Certification", name: "gardenCertification" },
          // { title: "Quality Certification", name: "qualityCertification" },
          // { title: "Color of Brew", name: "brewColor" },
          // { title: "Age of Products (In Months)", name: "ageOfProducts" },
          // { title: "Brewers Comments", name: "brewersComments" },
        ];

  const handleAccordionChange = (panel) => (_, isExpanded) => {
    setExpandedTab(isExpanded ? panel : null);

    // setDisable(false);
    // setIsEdit(false);
  };
  const handleExportExcel = async () => {
    // Assuming columnName contains the list of objects with "name" and "title"
    // let columnsdata = sellProgramsForAuctioneer;
    let columnsdata =
      userRole === "buyer"
        ? auctionCatalogUrl !== "EnglishAuctionBuyer"
          ? [
              // {
              //   title: ,
              //   name: ".",
              //   getCellValue: ({ ...row }) => (
              //     <>
              //       <input
              //         type="checkbox"
              //         checked={selectedData.some(
              //           (selectedRow) =>
              //             selectedRow.KutchaCatalogId === row.KutchaCatalogId
              //         )}
              //         onChange={() => handleCheckboxChange(row)}
              //       />
              //     </>
              //   ),
              // },
              { title: "Season", name: "season" },
              { title: "Sale No", name: "saleNo" },
              { title: "Auctioner Code", name: "auctioneerCode" },
              { title: "Auction Date", name: "auctionDate" },
              { title: "Session Time", name: "sessionTime" },
              { title: "Lot No.", name: "LotNo" },
              { title: "Origin", name: "Origin" },
              { title: "Tea Type", name: "teaTypeName" },
              { title: "Sub Type", name: "subTeaTypeName" },
              { title: "Category", name: "categoryName" },
              { title: "Mark", name: "markName" },
              { title: "Grade", name: "gradeName" },
              { title: "No. of Packages", name: "totalPackages" },
              { title: "Gross Weight", name: "grossKgs" },
              { title: "Net Weight", name: "netKgs" },
              { title: "SampleQty(Kgs)", name: "SampleQty" },
              { title: "Invoice Weight", name: "invoiceQty" },
              {
                title: "Period of Manufacture",
                name: "periodOfManufacture",
                // getCellValue: ({ ...row }) =>
                //   newformatDateToDdMmYy(row.periodOfManufacture.split("to")[1]),
              },
              { title: "Base Price", name: "basePrice" },
              { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
              { title: "Price Increment", name: "priceIncrement" },
              { title: "LastSoldPrice", name: "LSP_SP" },
              {
                title: "Mark & Packaging Comments",
                name: "markPackageComments",
              },
              { title: "Lot Comments", name: "lotComments" },
              { title: "Market Type (Lot Type)", name: "marketTypeName" },
              { title: "GP No.", name: "gpNo" },
              { title: "GP Date", name: "gpDate" },
              { title: "Invoice No.", name: "invoiceNo" },
              { title: "Package Type", name: "packageType" },
              { title: "Package No.", name: "packageNo" },
              { title: "Warehouse Name", name: "wareHouseName" },
              { title: "Garden Certification", name: "gardenCertification" },
              { title: "Quality Certification", name: "qualityCertification" },
              { title: "Color of drew", name: "brewColor" },
              { title: "Age of Product (In months)", name: "ageOfProducts" },
              { title: "Brewers Comments", name: "brewersComments" },
              // { title: "Reserve Price", name: "reservePrice" },
              // { title: "LSP / SP", name: "LSP_SP" },
              // { title: "Quality Comments", name: "qualityComments" },

              // { title: "Tare Weight", name: "tareKgs" },
              // { title: "Short accses Weight", name: "shortAccsesWeight" },

              // { title: "System Base Price", name: "SystemBasePrice" },
              // { title: "SBP_LSP/SP", name: "SBP_LSP_SP" },
            ]
          : [
              { title: "Season", name: "season" },
              { title: "Sale No", name: "saleNo" },
              { title: "Auctioner Code", name: "auctioneerCode" },
              { title: "Auction Date", name: "auctionDate" },
              { title: "Session Time", name: "sessionTime" },
              { title: "Lot No.", name: "LotNo" },
              { title: "Origin", name: "Origin" },
              { title: "Tea Type", name: "teaTypeName" },
              { title: "Sub Type", name: "subTeaTypeName" },
              { title: "Category", name: "categoryName" },
              { title: "Mark", name: "markName" },
              { title: "Grade", name: "gradeName" },
              { title: "No. of Packages", name: "totalPackages" },
              { title: "Gross Weight", name: "grossKgs" },
              { title: "Net Weight", name: "netKgs" },
              { title: "Sample Qty. (KGs)", name: "SampleQty" },
              { title: "Invoice Weight", name: "invoiceQty" },
              {
                title: "Period of Manufacture",
                name: "periodOfManufacture",
              },
              { title: "Base Price", name: "basePrice" },
              // { title: "Price Increment", name: "priceIncrement" },
              { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
              { title: "LSP/SP", name: "LSP_SP" },
              {
                title: "Mark & Packaging Comments",
                name: "markPackageComments",
              },
              { title: "Lot Comments", name: "lotComments" },
              { title: "Market Type (Lot Type)", name: "lotType" },
              { title: "GP No.", name: "gpNo" },
              { title: "GP Date", name: "gpDate" },
              { title: "Invoice No.", name: "invoiceNo" },
              { title: "Package Type", name: "packageType" },
              { title: "Package No.", name: "packageNo" },
              { title: "Warehouse Unit Code", name: "wareHouseName" },
              
              // { title: "Garden Certification", name: "gardenCertification" },
              // { title: "Quality Certification", name: "qualityCertification" },
              // { title: "Color of Brew", name: "brewColor" },
              // { title: "Age of Products (In Months)", name: "ageOfProducts" },
              // { title: "Brewers Comments", name: "brewersComments" },
            ]
        : [
            { name: "saleNo", title: "Sale No" },
            { title: "Season", name: "season" },
            { title: "Auctioner Code", name: "auctioneerCode" },
              { title: "Session Time", name: "sessionTime" },
            ...sellProgramsForAuctioneer,
          ];

    // //debugger;
    // columnsdata.pop();
    const columnName = columnsdata;

    // Assuming data contains the list of data objects like [{saleNo: 5}, ...]
    const data =
      userRole === "buyer"
        ? rows.map((ele) => {
            const { invoiceId, ...rest } = ele;
            return {
              ...rest,
              saleNo: formik.values.saleNo,
              season: formik.values.season,
              auctionDate: formik.values.auctionDate,
              // sessionTime: formik.values.sessionTime,
            };
          })
        : rows.map((ele) => {
            const { invoiceId, ...rest } = ele;
            return {
              ...rest,
              saleNo: formik.values.saleNo,
              season: formik.values.season,
            };
          });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("AuctionCatalog");

    // Define the types for specific columns

    // Create columns in the worksheet
    // columnName?.forEach((column) => {
    //   const excelColumn = worksheet?.addColumn({
    //     header: column.title,
    //     key: column.name,
    //   });

    //   if (dateColumns.includes(column.name)) {
    //     excelColumn.type = "date";
    //     // Optionally, set date format for the column
    //     // excelColumn.numFmt = 'mm/dd/yyyy'; // Date format
    //   } else if (textColumns.includes(column.name)) {
    //     excelColumn.type = "string";
    //   } else {
    //     excelColumn.type = "general";
    //   }
    //   // You can add more conditions for other types like numbers, currencies, etc.
    // });

    // Create a map from name to title for efficient lookup
    const nameToTitleMap = new Map();
    columnName.forEach((column) => {
      nameToTitleMap.set(column.name, column.title);
    });

    // Create the header row based on the columnName array
    const headerRow = worksheet.addRow(
      columnName.map((column) => column.title)
    );

    headerRow.eachCell((cell) => {
      cell.font = {
        bold: true,
        color: { argb: "FFFFFF" },

        // Text color set to white
      };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "183e29" }, // Background color (you can change the color code)
      };
    });

    // Add data rows based on columnName and data
    data.forEach((row) => {
      const rowData = columnName.map((column) => row[column.name]);

      worksheet.addRow(rowData);
      // worksheet.addRow(rowData).eachCell((cell) => {
      //   cell.fill = {
      //     type: "date",
      //   };
      // });
    });

    console.log(data, "datatata");

    // Automatically adjust column widths based on content
    worksheet.columns.forEach((column, index) => {
      const headerLength = columnName[index].title.length;
      const maxColumnWidth = column.values.reduce((acc, val) => {
        const cellLength = val ? val.toString().length : 0;
        return Math.max(acc, cellLength);
      }, headerLength);
      column.width = maxColumnWidth + 5; // Adding extra width for padding
    });

    const buffer = await workbook.xlsx.writeBuffer();

    // Convert the buffer to a Blob
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Save the Blob as a file
    saveAs(blob, "AuctionCatalog.xlsx");
  };

  const handleExportExcelMyCatalog = async () => {
    // Assuming columnName contains the list of objects with "name" and "title"
    let columnsdata = [];
    if (
      userRole?.toLowerCase() === "auctioneer" ||
      userRole?.toLowerCase() === "teaboard"
    ) {
      let filtered = myCatalogForAuctioneer.filter(
        (ele) => ele.title !== "Action"
      );
      let newItem = { title: "Auctioner Code", name: "auctioneerCode" };
      columnsdata = [...filtered.slice(0, 3), newItem, ...filtered.slice(3)];
      // columnsdata = [...myCatalogForAuctioneer?.filter((ele) => ele.title !== "Action"), { title: "Auctioner Code", name: "auctioneerCode" }]
    }
    // : myCatalogForBuyer?.filter((ele) => ele.title !== "Action");
    else {
      columnsdata =
        auctionCatalogUrl === "EnglishAuctionBuyer"
          ? [
              { title: "Season", name: "season" },
              { title: "Sale No.", name: "saleNo" },
              {
                title: "Auction Date",
                name: "auctionDate",
              },
              { title: "Auctioner Code", name: "auctioneerCode" },
              { title: "Category", name: "categoryName" },
              { title: "Session Time", name: "sessionTime" },
              { title: "Lot No.", name: "lotNo" },
              { title: "Origin", name: "origin" },
              { title: "Tea Type", name: "teaTypeName" },
              { title: "Sub Type", name: "subTeaTypeName" },
              { title: "Mark", name: "markName" },
              { title: "Grade", name: "gradeName" },
              { title: "Group Code", name: "groupCode" },
              { title: "No. of Packages", name: "totalPackages" },
              { title: "Gross Weight", name: "grossKgs" },
              { title: "Net Weight", name: "netKgs" },
              { title: "Invoice Weight", name: "invoiceQty" },
              {
                title: "Period of Manufacture (From to To)",
                name: "periodOfManufacture",
              },
              { title: "Base Price", name: "basePrice" },
              { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
              { title: "LSP/SP", name: "LSP_SP" },
              {
                title: "Mark & Packaging Comments",
                name: "markPackageComments",
              },
              { title: "Lot Comments", name: "lotComments" },
              { title: "Market Type (Lot Type)", name: "lotType" },
              { title: "My Comments", name: "myComments" },
              { title: "My Valuation", name: "myValuation" },
              { title: "GP No.", name: "gpNo" },
              { title: "GP Date", name: "gpDate" },
              { title: "Invoice No.", name: "invoiceNo" },
              { title: "Package Type", name: "packageType" },
              { title: "Package No.", name: "packageNo" },
              { title: "Warehouse Unit Code", name: "wareHouseName" },
            ]
          : [
              { title: "Season", name: "season" },
              { title: "Sale No.", name: "saleNo" },
              {
                title: "Auction Date",
                name: "auctionDate",
                getCellValue: ({ ...row }) =>
                  row.auctionDate?.split("T")?.at(0),
              },
              { title: "Auctioner Code", name: "auctioneerCode" },
              { title: "Session Time", name: "sessionTime" },
              { title: "Lot No.", name: "lotNo" },
              { title: "Origin", name: "origin" },
              { title: "Tea Type", name: "teaTypeName" },
              { title: "Sub Type", name: "subTeaTypeName" },
              { title: "Category", name: "categoryName" },
              { title: "Mark", name: "markName" },
              { title: "Grade", name: "gradeName" },
              { title: "Group Code", name: "groupCode" },
              { title: "No. of Packages", name: "totalPackages" },
              { title: "Gross Weight", name: "grossKgs" },
              { title: "Net Weight", name: "netKgs" },
              { title: "Invoice Weight", name: "invoiceQty" },
              {
                title: "Period of Manufacture",
                name: "periodOfManufacture",
              },
              { title: "Base Price", name: "basePrice" },
              { title: "Price Increment", name: "priceIncrement" },
              { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
              { title: "Last Sold Price", name: "LSP_SP" },
              {
                title: "Mark & Packaging Comments",
                name: "markPackageComments",
              },
              { title: "Lot Comments", name: "lotComments" },
              { title: "Market Type", name: "marketTypeName" },
              { title: "My Comments", name: "myComments" },
              { title: "My Valuation", name: "myValuation" },
              { title: "GP No.", name: "gpNo" },
              { title: "GP Date", name: "gpDate" },
              { title: "Invoice No.", name: "invoiceNo" },
              { title: "Package Type", name: "packageType" },
              { title: "Package No.", name: "packageNo" },
              { title: "Warehouse Name", name: "wareHouseName" },
              { title: "Garden Certification", name: "gardenCertification" },
              { title: "Quality Certification", name: "qualityCertification" },
              { title: "Color of Brew", name: "brewColor" },
              { title: "Age of Products (In months)", name: "ageOfProducts" },
              { title: "Brewers Comments", name: "brewersComments" },
            ];
    }
    // columnsdata.pop();
    const columnName = columnsdata;

    // Assuming data contains the list of data objects like [{saleNo: 5}, ...]
    const data = myCatalogRows.map((ele) => {
      const { invoiceId, ...rest } = ele;
      return rest;
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("AuctionCatalog");

    // Define the types for specific columns

    // Create columns in the worksheet
    // columnName?.forEach((column) => {
    //   const excelColumn = worksheet?.addColumn({
    //     header: column.title,
    //     key: column.name,
    //   });

    //   if (dateColumns.includes(column.name)) {
    //     excelColumn.type = "date";
    //     // Optionally, set date format for the column
    //     // excelColumn.numFmt = 'mm/dd/yyyy'; // Date format
    //   } else if (textColumns.includes(column.name)) {
    //     excelColumn.type = "string";
    //   } else {
    //     excelColumn.type = "general";
    //   }
    //   // You can add more conditions for other types like numbers, currencies, etc.
    // });

    // Create a map from name to title for efficient lookup
    const nameToTitleMap = new Map();
    columnName.forEach((column) => {
      nameToTitleMap.set(column.name, column.title);
    });

    // Create the header row based on the columnName array
    const headerRow = worksheet.addRow(
      columnName.map((column) => column.title)
    );

    headerRow.eachCell((cell) => {
      cell.font = {
        bold: true,
        color: { argb: "FFFFFF" },

        // Text color set to white
      };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "183e29" }, // Background color (you can change the color code)
      };
    });

    // Add data rows based on columnName and data
    data.forEach((row) => {
      const rowData = columnName.map((column) => row[column.name]);

      worksheet.addRow(rowData);
      // worksheet.addRow(rowData).eachCell((cell) => {
      //   cell.fill = {
      //     type: "date",
      //   };
      // });
    });

    console.log(columnName, data, "datatata");
    // //debugger;

    // Automatically adjust column widths based on content
    worksheet.columns.forEach((column, index) => {
      const headerLength = columnName[index].title.length;
      const maxColumnWidth = column.values.reduce((acc, val) => {
        const cellLength = val ? val.toString().length : 0;
        return Math.max(acc, cellLength);
      }, headerLength);
      column.width = maxColumnWidth + 5; // Adding extra width for padding
    });

    const buffer = await workbook.xlsx.writeBuffer();

    // Convert the buffer to a Blob
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Save the Blob as a file
    saveAs(blob, "MyCatalog.xlsx");
  };
  console.log(auctionCatalogUrl, "auctionCatalogUrl");
  const sellProgramsForAuctioneer =
    auctionCatalogUrl === "AuctionCatalog"
      ? [
          {
            title: "Lot No",
            name: "LotNo",
          },
          { title: "Invoice No.", name: "invoiceNo" },
          { title: "Origin", name: "Origin" },
          { title: "Tea Type", name: "teaTypeName" },
          { title: "Sub Type", name: "subTeaTypeName" },
          { title: "Category", name: "categoryName" },
          { title: "Mark", name: "markName" },
          { title: "Grade", name: "gradeName" },
          { title: "No. of Packages", name: "totalPackages" },
          { title: "Gross Weight", name: "grossKgs" },
          { title: "Tare Weight", name: "tareKgs" },
          { title: "Net Weight", name: "netKgs" },
          { title: "Sample Qty. (KGs)", name: "SampleQty" },
          { title: "Invoice Weight", name: "invoiceWeight" },
          { title: "GP No.", name: "gpNo" },
          { title: "GP Date", name: "gpDate" },
          {
            title: "Period of Manufacture (From to To)",
            name: "periodOfManufacture",
          },
          {
            title: "Base Price",
            name: "basePrice",
          },
          // { title: "Reserve Price", name: "reservePrice" },
          { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
          { title: "Price Increment", name: "priceIncrement" },
          { title: "LSP / SP", name: "LSP_SP" },
          { title: "Mark & Packaging Comments", name: "markPackageComments" },
          { title: "Lot Comments", name: "lotComments" },
          { title: "Market Type (Lot Type)", name: "marketTypeName" },

          // { title: "Quality Comments", name: "qualityComments" },
          { title: "Package Type", name: "packageType" },
          { title: "Package No.", name: "packageNo" },

          // { title: "Short accses Weight", name: "shortAccsesWeight" },

          { title: "Warehouse Unit Code", name: "wareHouseName" },
          { title: "Garden Certification", name: "gardenCertification" },
          { title: "Quality Certification", name: "qualityCertification" },
          { title: "Color of Brew", name: "brewColor" },
          { title: "Age of Products (In Months)", name: "ageOfProducts" },
          { title: "Brewers Comments", name: "brewersComments" },
          { title: "System Base Price", name: "SBP" },
          { title: "SBP_LSP/SP", name: "SBP_LSP_SP" },
          //
          // {
          //   title: "Auction",
          //   name: "auction",
          //   getCellValue: ({ ...row }) => (
          //     <>
          //       <a type="button" onClick={() => setOpenUploadUpdateValuation(true)}>
          //         <i class="fa fa-edit"></i>
          //       </a>
          //     </>
          //   ),
          // },
        ]
      : [
          {
            title: "Lot No.",
            name: "LotNo",
          },
          { title: "Mark", name: "markName" },
          { title: "Invoice No.", name: "invoiceNo" },
          { title: "Grade", name: "gradeName" },
          { title: "No. of Packages", name: "totalPackages" },
          {
            title: "Base Price",
            name: "basePrice",
          },

          // { title: "Reserve Price", name: "reservePrice" },
          { title: "Auctioneer's Valuation", name: "auctioneerValuation" },
          // { title: "Price Increment", name: "priceIncrement" },
          { title: "LSP / SP", name: "LSP_SP" },
          { title: "Lot Comments", name: "lotComments" },
          { title: "Market Type (Lot Type)", name: "lotType" },
          // { title: "LSP / SP", name: "LSP_SP" },
          // { title: "Quality Comments", name: "qualityComments" },
          { title: "Origin", name: "Origin" },
          { title: "Tea Type", name: "teaTypeName" },
          { title: "Sub Type", name: "subTeaTypeName" },
          { title: "Category", name: "categoryName" },
          { title: "Package Type", name: "packageType" },
          { title: "Package No.", name: "packageNo" },
          { title: "Gross Weight", name: "grossKgs" },
          { title: "Tare Weight", name: "tareKgs" },
          { title: "Net Weight", name: "netKgs" },
          { title: "Sample Qty. (KGs)", name: "SampleQty" },
          { title: "Invoice Weight", name: "invoiceWeight" },
          // { title: "Short accses Weight", name: "shortAccsesWeight" },
          { title: "GP No.", name: "gpNo" },
          { title: "GP Date", name: "gpDate" },
          {
            title: "Period of Manufacture (From to To)",
            name: "periodOfManufacture",
          },
          { title: "Mark & Packaging Comments", name: "markPackageComments" },
          // { title: "Market Type (Lot Type)", name: "lotType" },
          { title: "Warehouse Unit Code", name: "wareHouseName" },
          // { title: "Garden Certification", name: "gardenCertification" },
          // { title: "Quality Certification", name: "qualityCertification" },
          // { title: "Color of Brew", name: "brewColor" },
          // { title: "Age of Products (In Months)", name: "ageOfProducts" },
          // { title: "Brewers Comments", name: "brewersComments" },
          // // { title: "System Base Price", name: "SBP" },
          // { title: "SBP_LSP/SP", name: "SBP_LSP_SP" },
          // { title: "Lot Comments", name: "lotComments" },
          // {
          //   title: "Auction",
          //   name: "auction",
          //   getCellValue: ({ ...row }) => (
          //     <>
          //       <a type="button" onClick={() => setOpenUploadUpdateValuation(true)}>
          //         <i class="fa fa-edit"></i>
          //       </a>
          //     </>
          //   ),
          // },
        ];
  let exportColumns;
  let exportColumnsmyCatalog;

  if (userRole === "buyer") {
    const updatedArray = [...sellProgramsForBuyer];
    updatedArray.splice(3, 0, {
      title: "Auctioner Code",
      name: "auctioneerCode",
    });
    exportColumns = updatedArray;
  } else {
    const updatedArray = [...sellProgramsForAuctioneer];
    updatedArray.splice(3, 0, {
      title: "Auctioner Code",
      name: "auctioneerCode",
    });
    exportColumns = updatedArray;
  }

  if (
    userRole?.toLowerCase() === "auctioneer" ||
    userRole?.toLowerCase() === "teaboard"
  ) {
    const updatedArray = [...myCatalogForAuctioneer];
    updatedArray.splice(3, 0, {
      title: "Auctioner Code",
      name: "auctioneerCode",
    });
    exportColumnsmyCatalog = updatedArray;
  } else {
    const updatedArray = [...myCatalogForBuyer];
    updatedArray.splice(3, 0, {
      title: "Auctioner Code",
      name: "auctioneerCode",
    });
    exportColumnsmyCatalog = updatedArray;
  }
  const fngetmycatalog = () => {
    if (userRole === "buyer") {
      // axiosMain.post("/preauction/Buyer/AddToMyCatalog")
      formik.values.sessionStartTime = timeData?.split(" - ")?.at(0);
      formik.values.sessionEndTime = timeData?.split(" - ")[1];
      let datatime;
      let sttime;
      let endtime;
      if (
        formik.values.sessionTime !== "" &&
        formik.values.sessionTime !== undefined
      ) {
        datatime = formik.values.sessionTime.split("-");
        // sttime = datatime[0].slice(0, -5);
        // endtime = datatime[1].slice(0, -4);
        sttime = datatime[0].replace(" ", "");
        endtime = datatime[1].replace(" ", "");
      } else {
        sttime = "";
        endtime = "";
      }
      axiosMain
        .post(
          `/preauction/${auctionCatalogUrl}/GetMyCatalog?role=` +
            loggedUser?.userCode,
          // auctionCatalogUrl === "Buyer"
          //   ? {
          //     season: formik.values.season,
          //     saleNo: parseInt(formik.values.saleNo),
          //     auctionDate: formik.values.auctionDate,
          //     buyerId: userId,
          //     // userId: formik.values.auctioneer,
          //     sessionTime: formik.values.sessionTime,
          //     teaTypeId:
          //       teatypeList.filter(
          //         (ele) => ele.teaTypeId === parseInt(formik.values.teaType)
          //       )[0]?.teaTypeName === "BOTH"
          //         ? 0
          //         : parseInt(formik.values.teaType),
          //     categoryId: formik.values.category,
          //     sessionStartTime: sttime,
          //     sessionEndTime: endtime,
          //     auctionCenterId: auctionCenterId,
          //   }
          //   :
          {
            season: formik.values.season,
            saleNo: parseInt(formik.values.saleNo),
            auctionDate: formik.values.auctionDate,
            buyerId: userId,
            // userId: formik.values.auctioneer,
            sessionTime: formik.values.sessionTime,
            teaTypeId:
              teatypeList.filter(
                (ele) => ele.teaTypeId === parseInt(formik.values.teaType)
              )[0]?.teaTypeName === "BOTH"
                ? 0
                : parseInt(formik.values.teaType),
            categoryId: formik.values.category,
            sessionStartTime: formik.values.sessionStartTime,
            sessionEndTime: formik.values.sessionEndTime,
            auctionCenterId: auctionCenterId,
            gradeId:
              formik.values.grade === "" || formik.values.grade === undefined
                ? 0
                : parseInt(formik.values.grade),
            markId:
              formik.values.mark === "" || formik.values.mark === undefined
                ? 0
                : parseInt(formik.values.mark),
            origin: formik.values.origin ? formik.values.origin : "",
          }
        )
        .then((res) => {
          if (res.data.statusCode === 200) {
            //CustomToast.success(res.data.message);
            setMyCatalogRows(res.data.responseData);
            setSelectedData([]);
            setSelectedDataMyCatalogdata([]);
            setSelectedRows([]);
            //set session type id
            setsessionTypeId(res.data?.responseData[0]?.sessionTypeId);
          } else {
            //CustomToast.error(res.data.message);
            setMyCatalogRows([]);
          }
        });

      // console.log(KutchaCatalogId);
    } else {
      if (formik.values.saleNo !== "") {
        // formik.values.sessionStartTime =
        //   formik.values.sessionTime
        //     ?.at(0)
        //     ?.SessionTime?.split(" - ")
        //     ?.at(0);
        // formik.values.sessionEndTime = formik.values.sessionTime
        //   ?.at(0)
        //   ?.SessionTime?.split(" - ")[1];

        let datatime;
        let sttime;
        let endtime;
        if (
          formik.values.sessionTime !== "" &&
          formik.values.sessionTime !== undefined
        ) {
          datatime = formik.values.sessionTime.split("-");
          // sttime = datatime[0].slice(0, -5);
          // endtime = datatime[1].slice(0, -4);
          sttime = datatime[0].replace(" ", "");
          endtime = datatime[1].replace(" ", "");
        } else {
          sttime = "";
          endtime = "";
        }
        openLoader();
        console.log(formik.values);
        axiosMain
          .post(
            `/preauction/${auctionCatalogUrl}/GetMyCatalog?role=` +
              loggedUser?.userCode,
            {
              // axios
              // .post(
              //   "http://192.168.101.221:5080/preauction/AuctionCatalog/GetMyCatalog?role=" +
              //     loggedUser?.userCode,
              //   {
              season: formik.values.season,
              saleNo: parseInt(formik.values.saleNo),
              auctionDate: formik.values.auctionDate,
              // auctioneerId: formik.values.auctioneer,

              auctioneerId: userId,
              auctionCenterId: auctionCenterId,
              userId: userId,
              // userId: formik.values.auctioneer,
              // teaTypeId: formik.values.teaType,
              teaTypeId:
                teatypeList.filter(
                  (ele) => ele.teaTypeId === parseInt(formik.values.teaType)
                )[0]?.teaTypeName === "BOTH"
                  ? 0
                  : parseInt(formik.values.teaType),
              categoryId: formik.values.category,
              sessionStartTime: sttime,
              sessionEndTime: endtime,
            }
          )
          .then((res) => {
            if (res.data.statusCode === 200) {
              //CustomToast.success(res.data.message);
              let data = res.data?.responseData?.map((ele) => {
                return {
                  ...ele,
                  saleDate: formatDateToDdMmYy(ele.saleDate),
                  gpDate: formatDateToDdMmYy(ele.gpDate),
                };
              });
              setMyCatalogRows(data);
            } else {
              //CustomToast.error(res.data.message);
            }
            closeLoader();
          });
      }
    }
  };
  const handleDownload = () => {
    let documentName = "AuctionCata.xlsx";

    axiosMain
      .post(
        `/preauction/${
          auction === "ENGLISH" ? "EnglishAuctionCatalog" : "AuctionCatalog"
        }/DownloadAuctionCatalogReportExcel?role=` + loggedUser?.userCode,
        // axios
        //   .post(
        //     `http://192.168.101.221:5080/preauction/${auctionCatalogUrl}/DownloadAuctionCatalogReportExcel?role=` +
        //       loggedUser?.userCode,
        {
          SaleProgramId: saleProgramId,
          auctionCenterId: auctionCenterId,
          userId: userId,
          Type: userRole === "buyer" ? "For Buyer" : "Normal",
          auctionDate: formik.values.auctionDate,
          auctioneerId: parseInt(formik.values.auctioneerId),
          teaTypeId:
            teatypeList.filter(
              (ele) => ele.teaTypeId === parseInt(formik.values.teaType)
            )[0]?.teaTypeName === "BOTH"
              ? 0
              : parseInt(formik.values.teaType),

          categoryId:
            formik.values.category == "" ? 0 : parseInt(formik.values.category),
          // sessionStartTime:
          //   formik.values.sessionTime?.split(" - ") === undefined
          //     ? formik.values.sessionTime?.split(" - ")?.at(0)
          //     : "",
          // sessionEndTime:
          //   formik.values.sessionTime?.split(" - ") === undefined
          //     ? formik.values.sessionTime?.split(" - ")?.at(1)
          //     : "",

          sessionStartTime:
            formik.values.sessionStartTime === undefined
              ? formik.values.sessionTime?.split(" - ") !== undefined
                ? formik.values.sessionTime?.split(" - ")?.at(0)
                : ""
              : "",
          sessionEndTime:
            formik.values.sessionEndTime === undefined
              ? formik.values.sessionTime?.split(" - ") !== undefined
                ? formik.values.sessionTime?.split(" - ")?.at(1)
                : ""
              : "",
          auctionCenterId: auctionCenterId,
          gradeId:
            formik.values.grade === "" || formik.values.grade === undefined
              ? 0
              : parseInt(formik.values.grade),
          markId:
            formik.values.mark === "" || formik.values.mark === undefined
              ? 0
              : parseInt(formik.values.mark),
        }
        // rows?.map((ele) => {
        //   return { LotNo: ele.LotNo };
        // })
      )
      .then((res) => {
        let documentBytes = res?.data?.responseData[0]?.byteDatas;

        // Decode base64 encoded documentBytes
        const decodedBytes = atob(documentBytes);

        // Create a Blob from the decoded bytes
        const blob = new Blob([
          new Uint8Array([...decodedBytes].map((char) => char.charCodeAt(0))),
        ]);

        // Create an object URL from the Blob
        const blobUrl = URL.createObjectURL(blob);

        // Create a hidden anchor element
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.href = blobUrl;
        anchor.download = documentName;

        // Append anchor to the body
        document.body.appendChild(anchor);

        // Programmatically click the anchor element
        anchor.click();

        // Clean up: remove the anchor and revoke the object URL
        document.body.removeChild(anchor);
        URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => console.log(err));
  };
  const handleExportToPdf = () => {
    var newdat = rows?.map((obj) => {
      for (const key in obj) {
        if (obj[key] === undefined || obj[key] === null) {
          obj[key] = "";
        }
      }
      return obj;
    });
    var allcoulmn =
      userRole === "buyer" ? sellProgramsForBuyer : sellProgramsForAuctioneer;
    allcoulmn.push(
      { name: "season", title: "Season" },
      { name: "saleNo", title: "Sale No" },
      { title: "Auctioner Code", name: "auctioneerCode" }
    );
    setcolumndata(allcoulmn);

    var datas = newdat?.map((item) => ({
      ...item,
      season: formik.values.season,
      saleNo: formik.values.saleNo,
    }));
    setprintrow(datas);
    console.log(formik);
    setopenPrintModel(true);
  };
  const handleExportToPdfMyCatalog = () => {
    var newdat = myCatalogRows?.map((obj) => {
      for (const key in obj) {
        if (obj[key] === undefined || obj[key] === null) {
          obj[key] = "";
        }
      }
      return obj;
    });
    // var allcoulmn =
    //   userRole?.toLowerCase() === "auctioneer"
    //     ? myCatalogForAuctioneer.push({ title: "Auctioner Name", name: "auctionerName" })
    //     : myCatalogForBuyer;
    let allcoulmn;

    if (userRole?.toLowerCase() === "auctioneer") {
      const tempCatalog = [...myCatalogForAuctioneer]; // shallow copy
      tempCatalog.splice(3, 0, {
        title: "Auctioner Code",
        name: "auctioneerCode",
      });
      allcoulmn = tempCatalog;
    } else {
      allcoulmn = myCatalogForBuyer;
    }

    // allcoulmn.push(
    //   { name: "season", title: "Season" },
    //   { name: "saleNo", title: "Sale No" }
    // );
    // var datas = newdat.map((item) => ({ ...item, season: formik.values.season, saleNo: formik.values.saleNo }))
    // setprintrow(myCatalogRows);
    // console.log(formik);
    const objectToRemove = "action";

    // Find the index of the object with the specified name
    const indexToRemove = allcoulmn.findIndex(
      (item) => item.name === objectToRemove
    );

    // Check if the index is found and remove the object
    if (indexToRemove !== -1) {
      allcoulmn.splice(indexToRemove, 1);
    }
    var datas = newdat?.map((item) => ({
      ...item,
      season: formik.values.season,
      saleNo: formik.values.saleNo,
    }));
    setprintMyrow(datas);
    setcolumndatamycatalog(allcoulmn);

    setopenPrintModelMyCatalog(true);
  };
  // function handleRowDoubleClick(row) {
  //   console.log("Dublclick", row);
  // }
  // const handleRowDoubleClick = useCallback((row) => {
  //   //debugger;
  //   console.log("Double-clicked row data:", row);
  // }, []);

  // const TableRow = useCallback(
  //   ({ row, ...restProps }) => (
  //     <Table.Row
  //       {...restProps}
  //       onDoubleClick={(e) => console.log("hello")}
  //     />
  //   ),
  //   [handleRowDoubleClick]
  // );

  const fnGetMyCatalogValuationByParam = (row) => {
    openLoader();
    setOpenUploadUpdateValuation(true);
    setauctioncatalogIdforupload(row.KutchaCatalogId);
    axiosMain
      .post(
        `/preauction/${auctionCatalogUrl}/GetMyCatalogValuationByParam?role=` +
          loggedUser?.userCode,

        auctionCatalogUrl === "EnglishAuctionCatalog"
          ? {
              auctionCatalogId: row.auctionCatalogId,
              auctioneerId: userId,
              auctionCenterId: auctionCenterId,
              season: row.Season,
              saleNo: row.saleNo,
            }
          : {
              KutchaCatalogId: row.KutchaCatalogId,
              auctioneerId: userId,
              auctionCenterId: auctionCenterId,
              season: row.Season,
              saleNo: row.saleNo,
            }
      )
      .then((res) => {
        setGetDataByprems(res.data.responseData);
        closeLoader();
      })
      .catch((err) => {
        closeLoader();
        console.log(err);
      });
  };
  const handleCellClick = async (row, inputdata) => {
    //debugger;
    try {
      // Ensure the user has one of the required roles
      if (
        ["auctioneer", "teaboard", "taouser"].includes(userRole?.toLowerCase())
      ) {
        openLoader();
        setauctioncatalogIdforupload(row.KutchaCatalogId);

        const apiUrl = `/preauction/${auctionCatalogUrl}/GetMyCatalogValuationByParam?role=${loggedUser?.userCode}`;

        const payload =
          auctionCatalogUrl === "EnglishAuctionCatalog"
            ? {
                auctionCatalogId: row.auctionCatalogId,
                auctioneerId: userId,
                auctionCenterId: auctionCenterId,
                season: row.Season,
                saleNo: row.saleNo,
              }
            : {
                KutchaCatalogId: row.KutchaCatalogId,
                auctioneerId: userId,
                auctionCenterId: auctionCenterId,
                season: row.Season,
                saleNo: row.saleNo,
              };

        const response = await axiosMain.post(apiUrl, payload);
        closeLoader();
        // setGetDataByprems(response.data.responseData)
        return response.data.responseData;
      } else {
        return [row];
        closeLoader();
      }
    } catch (error) {
      closeLoader();
      console.error("API error:", error);
    } finally {
      closeLoader();
    }
  };

  // const handleValuationChange = (value) => {
  //   setMyCatalogRows((prevData) =>
  //     prevData.map((row) =>
  //       row.MyCatalogId === id ? { ...row, myValuation: value } : row
  //     )
  //   );

  //   setMyValuation(value)
  // };
  const [valuationMap, setValuationMap] = useState({});
  // const [editableCell, setEditableCell] = useState({ rowId: null, columnName: null });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectRow = (id) => {
    setSelectedRows(
      (prev) =>
        prev.includes(id)
          ? prev.filter((rowId) => rowId !== id) // Remove if already selected
          : [...prev, id] // Add if not selected
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]); // Deselect all
    } else {
      setSelectedRows(myCatalogRows.map((row) => row.MyCatalogId)); // Select all
    }
    setSelectAll(!selectAll);
  };
  const handleValuationChange = (value, id, colname) => {
    // setValuationMap((prev) => ({
    //   ...prev,
    //   [id]: value, // Only update the changed row
    //   name: colname
    // }));
    setValuationMap({
      [id]: value,
      name: colname,
    });
  };
  // , []);

  // const TableCell = useCallback(
  //   ({ row, column, ...restProps }) => (
  //     <Table.Cell
  //       {...restProps}
  //       onDoubleClick={() => handleCellClick(row, column)}
  //     />
  //   ),
  //   [handleCellClick]
  // );

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("dragIndex", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex, data, setData) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    const updatedColumns = [...data];
    const draggedColumn = updatedColumns.splice(dragIndex, 1)[0];
    updatedColumns.splice(dropIndex, 0, draggedColumn);
    setData(updatedColumns);
  };
  const handleRowClickchangeColor = (index) => {
    setRowcolorChange(index);
  };

  return (
    <div>
      <Accordion
        expanded={expandedTab === "panel1" || expandedTab === "All"}
        onChange={handleAccordionChange("panel1")}
        className={`${
          expandedTab === "panel1" || expandedTab === "All" ? "active" : ""
        }`}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Auction Catalog</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={formik.handleSubmit}>
            {/* <div className="row">
          <div className="col-lg-2">
            <div className="FormGroup">
              <label htmlFor="season">Season</label>
              <input
                type="text"
                id="season"
                name="season"
                className="form-control select-form"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.season}
              />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="FormGroup">
              <label htmlFor="saleNo">Sale No.</label>
              <input
                type="text"
                id="saleNo"
                name="saleNo"
                className="form-control select-form"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.saleNo}
              />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="FormGroup">
              <label htmlFor="auctionDate">Auction Date</label>
              <input
                type="text"
                id="auctionDate"
                name="auctionDate"
                className="form-control select-form"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.auctionDate}
              />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="FormGroup">
              <label htmlFor="auctioneer">Auctioneer</label>
              <input
                type="text"
                id="auctioneer"
                name="auctioneer"
                className="form-control select-form"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.auctioneer}
              />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="FormGroup">
              <label htmlFor="teaType">Tea Type</label>
              <input
                type="text"
                id="teaType"
                name="teaType"
                className="form-control select-form"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.teaType}
              />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="FormGroup">
            <label htmlFor="category">Category</label>
              <input
                type="text"
                id="category"
                name="category"
                className="form-control select-form"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.category}
              />
            </div>
          </div>
          <div className="col-lg-2">
            <div className="FormGroup">
              <label htmlFor="sessionTime">Session Time</label>
              <input
                type="text"
                id="sessionTime"
                name="sessionTime"
                className="form-control select-form"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.sessionTime}
              />
            </div>
          </div>
        </div> */}
            {modalRight?.includes("12") && (
              <div className="row">
                <div className="col-lg-2">
                  <div className="FormGroup">
                    <label htmlFor="season">Season</label>
                    <select
                      id="season"
                      name="season"
                      className="form-control select-form"
                      onChange={formik.handleChange}
                      value={formik.values.season}
                      onFocus={() => {
                        isDropdownOpen.current = true;
                      }}
                      onBlur={() => {
                        isDropdownOpen.current = false;
                      }}
                    >
                      {generateYearOptions()}
                    </select>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="FormGroup">
                    <label htmlFor="saleNo">Sale No.</label>
                    <select
                      id="saleNo"
                      name="saleNo"
                      className="form-control select-form"
                      onChange={formik.handleChange}
                      value={formik.values.saleNo}
                      onFocus={() => {
                        isDropdownOpen.current = true;
                      }}
                      onBlur={() => {
                        isDropdownOpen.current = false;
                      }}
                    >
                      {saleNo?.length > 0 ? (
                        saleNo?.map((item, index) => (
                          <option value={item.saleNo} key={item.saleNo}>
                            {item.saleNo}
                          </option>
                        ))
                      ) : (
                        <option>No Data</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="FormGroup">
                    <label htmlFor="auctionDate">Auction Date</label>
                    <select
                      id="auctionDate"
                      name="auctionDate"
                      className="form-control select-form"
                      onChange={formik.handleChange}
                      value={formik.values.auctionDate}
                      onFocus={() => {
                        isDropdownOpen.current = true;
                      }}
                      onBlur={() => {
                        isDropdownOpen.current = false;
                      }}
                    >
                      {auctionDates?.length > 0 ? (
                        auctionDates?.map((item, index) => (
                          <option value={item.saleDate} key={index}>
                            {newformatDateToDdMmYy(
                              item.saleDate?.split("T")?.at(0)
                            )}
                          </option>
                        ))
                      ) : (
                        <option>No Data</option>
                      )}
                      {/* Add more options as needed */}
                    </select>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="FormGroup">
                    <label htmlFor="auctioneer">Auctioneer</label>
                    <select
                      id="auctioneer"
                      name="auctioneerId"
                      className="form-control select-form"
                      onChange={formik.handleChange}
                      value={formik.values.auctioneerId}
                      onFocus={() => {
                        isDropdownOpen.current = true;
                      }}
                      onBlur={() => {
                        isDropdownOpen.current = false;
                      }}
                    >
                      <option value={0}>All</option>

                      {auctioneer?.length > 0 ? (
                        auctioneer?.map((item, index) => (
                          <option value={item.userId} key={item.userId}>
                            {item.userCode}
                          </option>
                        ))
                      ) : (
                        <option>No Data</option>
                      )}
                      {/* Add more options as needed */}
                    </select>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="FormGroup">
                    <label htmlFor="teaType">Tea Type</label>
                    <select
                      id="teaType"
                      name="teaType"
                      className="form-control select-form"
                      onChange={formik.handleChange}
                      value={formik.values.teaType}
                      onFocus={() => {
                        isDropdownOpen.current = true;
                      }}
                      onBlur={() => {
                        isDropdownOpen.current = false;
                      }}
                    >
                      <option value={0}>All</option>

                      {teatypeList?.length > 0 ? (
                        teatypeList?.map((item, index) => (
                          <option value={item.teaTypeId} key={index}>
                            {item.teaTypeName}
                          </option>
                        ))
                      ) : (
                        <option>No Data</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="FormGroup">
                    <label htmlFor="category">Category</label>
                    <select
                      id="category"
                      name="category"
                      className="form-control select-form"
                      onChange={formik.handleChange}
                      value={formik.values.category}
                      onFocus={() => {
                        isDropdownOpen.current = true;
                      }}
                      onBlur={() => {
                        isDropdownOpen.current = false;
                      }}
                    >
                      <option value={0}>All</option>

                      {category?.length > 0 ? (
                        category?.map((item, index) => (
                          <option value={item.categoryId} key={item.categoryId}>
                            {item.categoryCode}
                          </option>
                        ))
                      ) : (
                        <option>No Data</option>
                      )}
                      {/* Add more options as needed */}
                    </select>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="FormGroup">
                    <label htmlFor="sessionTime">Session Time</label>
                    <select
                      id="sessionTime"
                      name="sessionTime"
                      value={formik.values.sessionTime}
                      className="form-control select-form"
                      onChange={(e) => {
                        formik.handleChange(e);
                        setTimeData(e.target.value);
                      }}
                      onFocus={() => {
                        isDropdownOpen.current = true;
                      }}
                      onBlur={() => {
                        isDropdownOpen.current = false;
                      }}
                    >
                      <option value="">All</option>
                      {/* {sessionTime?.length > 0 ? ( */}
                      {sessionTime?.map((item, index) => (
                        <option value={item.SessionTime} key={index}>
                          {item.SessionTime}
                        </option>
                      ))}
                      {/* ) : (
                        <option>No Data</option>
                      )} */}
                      {/* Add more options as needed */}
                    </select>
                  </div>
                </div>
                {userRole === "buyer" && (
                  <>
                    <div className="col-lg-2">
                      <div className="FormGroup">
                        <label htmlFor="auctioneer">Mark</label>
                        <select
                          id="mark"
                          name="mark"
                          className="form-control select-form"
                          onChange={formik.handleChange}
                          value={formik.values.mark}
                          onFocus={() => {
                            isDropdownOpen.current = true;
                          }}
                          onBlur={() => {
                            isDropdownOpen.current = false;
                          }}
                        >
                          <option value={0}>All</option>

                          {markDataList?.length > 0
                            ? markDataList?.map((item, index) => (
                                <option value={item.markId} key={index}>
                                  {item.markCode}
                                </option>
                              ))
                            : "No Data"}
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="FormGroup">
                        <label htmlFor="grade">Grade</label>
                        <select
                          id="grade"
                          name="grade"
                          className="form-control select-form"
                          onChange={formik.handleChange}
                          value={formik.values.grade}
                          onFocus={() => {
                            isDropdownOpen.current = true;
                          }}
                          onBlur={() => {
                            isDropdownOpen.current = false;
                          }}
                        >
                          <option value={0}>All</option>

                          {gradesList?.length > 0
                            ? gradesList?.map((item, index) => (
                                <option value={item.gradeId} key={index}>
                                  {item.gradeCode}
                                </option>
                              ))
                            : "No Data"}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-2">
                      <div className="FormGrup">
                        <label>Origin</label>
                        <select
                          id="origin"
                          name="origin"
                          className="form-control select-form"
                          onChange={formik.handleChange}
                          value={formik.values.origin}
                          onFocus={() => {
                            isDropdownOpen.current = true;
                          }}
                          onBlur={() => {
                            isDropdownOpen.current = false;
                          }}
                          // disabled
                        >
                          <option value={""}>All</option>

                          {originDataList?.length > 0
                            ? originDataList?.map((item, index) => (
                                <option value={item.originCode} key={index}>
                                  {item.originCode}
                                </option>
                              ))
                            : "No Data"}
                        </select>
                        {/* <div className="max-width250"> */}
                        {/* <InputGroup>
                            <FormControl
                              as="select"
                              name="origin"
                              onChange={formik.handleChange}
                              value={formik.values.origin}
                            >
                              {originDataList?.length > 0
                                ? originDataList?.map((item, index) => (
                                  <option value={item.originCode} key={index}>
                                    {item.originCode}
                                  </option>
                                ))
                                : "No Data"}
                            </FormControl>
                          </InputGroup> */}
                        {formik.errors.origin && formik.touched.origin && (
                          <div className="error text-danger">
                            {formik.errors.origin}
                          </div>
                        )}
                        {/* </div> */}
                      </div>
                    </div>
                  </>
                )}

                <div className="col-12">
                  <div className="BtnGroup">
                    {modalRight?.includes("12") && (
                      <button
                        type="submit"
                        className="SubmitBtn"
                        // onClick={formik.handleSubmit}
                      >
                        Search
                      </button>
                    )}

                    {/* {modalRight?.includes("9") && (
                      <button className="SubmitBtn" onClick={handleExportExcel}>
                        Export as Excel
                      </button>
                    )} */}
                    {modalRight?.includes("7") && (
                      <button
                        type="button"
                        className="SubmitBtn"
                        onClick={handleDownload}
                      >
                        Download Format
                      </button>
                    )}

                    {userRole === "buyer" ? (
                      <button
                        type="button"
                        className="SubmitBtn"
                        onClick={() => {
                          if (userRole === "buyer") {
                            let KutchaCatalogId = "";
                            let auctionCatalogId = "";
                            if (selectedDataAuctionCatalogdata?.length > 0) {
                              selectedDataAuctionCatalogdata
                                .map((ele) => rows[ele])
                                .map((ele) =>
                                  auctionCatalogUrl === "Buyer" ||
                                  auctionCatalogUrl === "Buyer"
                                    ? (KutchaCatalogId =
                                        KutchaCatalogId === ""
                                          ? ele.KutchaCatalogId?.toString()
                                          : KutchaCatalogId +
                                            "," +
                                            ele.KutchaCatalogId?.toString())
                                    : (auctionCatalogId =
                                        auctionCatalogId === ""
                                          ? ele.auctionCatalogId?.toString()
                                          : auctionCatalogId +
                                            "," +
                                            ele.auctionCatalogId?.toString())
                                );
                              openLoader();
                              axiosMain
                                .post(
                                  `/preauction/${auctionCatalogUrl}/AddToMyCatalog`,
                                  auctionCatalogUrl === "Buyer"
                                    ? {
                                        kutchaCatalogIds: KutchaCatalogId,
                                        SaleProgramId: saleProgramId,
                                        buyerId: userId,
                                        auctionCenterId: auctionCenterId,
                                        sessionTypeId: parseInt(
                                          rows[0].sessionTypeId
                                        ),
                                      }
                                    : {
                                        auctionCatalogIds: auctionCatalogId,
                                        SaleProgramId: saleProgramId,
                                        buyerId: userId,
                                        auctionCenterId: auctionCenterId,
                                        sessionTypeId: parseInt(
                                          rows[0].sessionTypeId
                                        ),
                                      }
                                )
                                .then((res) => {
                                  if (res.data.statusCode === 200) {
                                    CustomToast.success(res.data.message);
                                    formik.values.sessionStartTime = timeData
                                      ?.split(" - ")
                                      ?.at(0);
                                    formik.values.sessionEndTime =
                                      timeData?.split(" - ")[1];

                                    let datatime;
                                    let sttime;
                                    let endtime;
                                    if (
                                      formik.values.sessionTime !== "" &&
                                      formik.values.sessionTime !== undefined
                                    ) {
                                      datatime =
                                        formik.values.sessionTime.split("-");
                                      // sttime = datatime[0].slice(0, -5);
                                      // endtime = datatime[1].slice(0, -4);
                                      sttime = datatime[0].replace(" ", "");
                                      endtime = datatime[1].replace(" ", "");
                                    } else {
                                      sttime = "";
                                      endtime = "";
                                    }

                                    axiosMain
                                      .post(
                                        `/preauction/${auctionCatalogUrl}/GetMyCatalog?role=` +
                                          loggedUser?.userCode,
                                        // auctionCatalogUrl === "Buyer"
                                        //   ? {
                                        //     season: formik.values.season,
                                        //     saleNo: parseInt(
                                        //       formik.values.saleNo
                                        //     ),
                                        //     auctionDate:
                                        //       formik.values.auctionDate,
                                        //     buyerId: userId,
                                        //     // userId: formik.values.auctioneer,
                                        //     sessionTime:
                                        //       formik.values.sessionTime,

                                        //     teaTypeId:
                                        //       teatypeList.filter(
                                        //         (ele) =>
                                        //           ele.teaTypeId ===
                                        //           parseInt(
                                        //             formik.values.teaType
                                        //           )
                                        //       )[0]?.teaTypeName === "BOTH"
                                        //         ? 0
                                        //         : parseInt(
                                        //           formik.values.teaType
                                        //         ),

                                        //     categoryId:
                                        //       formik.values.category,
                                        //     sessionStartTime: sttime,
                                        //     sessionEndTime: endtime,
                                        //     auctionCenterId: auctionCenterId,
                                        //   }
                                        //   :
                                        {
                                          season: formik.values.season,
                                          saleNo: parseInt(
                                            formik.values.saleNo
                                          ),
                                          auctionDate:
                                            formik.values.auctionDate,
                                          buyerId: userId,
                                          // userId: formik.values.auctioneer,
                                          sessionTime:
                                            formik.values.sessionTime,
                                          teaTypeId: formik.values.teaType,
                                          categoryId: formik.values.category,
                                          sessionStartTime:
                                            formik.values.sessionTime
                                              ?.split(" - ")
                                              ?.at(0),
                                          sessionEndTime:
                                            formik.values.sessionTime
                                              ?.split(" - ")
                                              ?.at(1),
                                          auctionCenterId: auctionCenterId,
                                          gradeId:
                                            formik.values.grade === "" ||
                                            formik.values.grade === undefined
                                              ? 0
                                              : parseInt(formik.values.grade),
                                          markId:
                                            formik.values.mark === "" ||
                                            formik.values.mark === undefined
                                              ? 0
                                              : parseInt(formik.values.mark),
                                          orirgin: formik.values.origin,
                                        }
                                      )
                                      .then((res) => {
                                        if (res.data.statusCode === 200) {
                                          setSelectedDataAuctionCatalogdata([]);
                                          // CustomToast.success(res.data.message);
                                          setMyCatalogRows(
                                            res.data.responseData
                                          );
                                          setSelectedData([]);
                                          setSelectedDataMyCatalogdata([]);
                                          setSelectedRows([]);
                                          //set session type id
                                          setsessionTypeId(
                                            res.data?.responseData[0]
                                              ?.sessionTypeId
                                          );
                                        } else {
                                          // CustomToast.error(res.data.message);
                                          setMyCatalogRows([]);
                                        }
                                        closeLoader();
                                      });
                                    setSelectedData([]);
                                  } else {
                                    CustomToast.error(res.data.message);
                                    setSelectedData([]);
                                    closeLoader();
                                  }
                                });
                            } else {
                              CustomToast.error(
                                "Please select atleast one Lot No."
                              );
                            }
                          }
                        }}
                      >
                        Add to My Catalog
                      </button>
                    ) : (
                      ""
                    )}
                    <button
                      type="button"
                      className="SubmitBtn"
                      onClick={() => {
                        formik.resetForm();
                        dispatch(
                          fetchSaleNumbersRequest(
                            formik.values.season.toString()
                          )
                        );
                        setRows([]);
                        setMyCatalogRows([]);
                        setSelectedData([]);
                      }}
                    >
                      Clear
                    </button>
                    {modalRight?.includes("9") && (
                      <>
                        <Tooltip title="Print">
                          <button
                            type="button"
                            className="Excel"
                            onClick={handleExportToPdf}
                          >
                            <i className="fa fa-print"></i>
                          </button>
                        </Tooltip>
                        <Tooltip title="Export as Excel">
                          <button
                            type="button"
                            className="Excel"
                            onClick={handleExportExcel}
                          >
                            <i className="fa fa-file-excel"></i>
                          </button>
                        </Tooltip>

                        <ExportPDF
                          columns={
                            exportColumns
                            //     if(userRole === "buyer"){
                            //       const updatedArray = [...sellProgramsForBuyer]; // Clone the original array
                            // updatedArray.splice(3, 0, {title: "Auctioner Code", name: "auctioneerCode" });

                            //     }
                            // else{
                            //       const updatedArray = [...sellProgramsForBuyer]; // Clone the original array
                            // updatedArray.splice(3, 0, {title: "Auctioner Code", name: "auctioneerCode" });

                            //     }
                            // ? [...sellProgramsForBuyer, {title: "Auctioner Code", name: "auctioneerCode" }]
                            // : [...sellProgramsForAuctioneer, {title: "Auctioner Code", name: "auctioneerCode" }]
                          }
                          data={
                            rows?.length > 0
                              ? rows.map((ele) => {
                                  const { invoiceId, ...rest } = ele;
                                  return rest;
                                })
                              : []
                          }
                          name={"AuctionCatalog"}
                          auctionType={
                            userRole === "buyer"
                              ? auctionCatalogUrl === "EnglishAuctionBuyer"
                                ? "ENGLISH"
                                : "BHARAT"
                              : auctionCatalogUrl === "EnglishAuctionCatalog"
                              ? "ENGLISH"
                              : "BHARAT"
                          }
                        />

                        <ExportHTMl
                          columns={
                            exportColumns
                            // userRole === "buyer"
                            //   ? [...sellProgramsForBuyer, { title: "Auctioner Code", name: "auctioneerCode" }]
                            //   : [...sellProgramsForAuctioneer, { title: "Auctioner Code", name: "auctioneerCode" }]
                          }
                          data={
                            rows?.length > 0
                              ? rows.map((ele) => {
                                  const { invoiceId, ...rest } = ele;
                                  return rest;
                                })
                              : []
                          }
                          name={"AuctionCatalog"}
                        />

                        {/* <ExportHTMl
                          columns={
                            userRole?.toLowerCase() ===
                              "auctioneer" ||
                            userRole?.toLowerCase() === "teaboard"
                              ? myCatalogForAuctioneer
                              : myCatalogForBuyer
                          }
                          data={myCatalogRows?.length > 0 ? myCatalogRows : []}
                          name={"MyCatalog"}
                        /> */}
                      </>
                    )}
                  </div>
                  {/* <ExportData
                  data={rows.map((ele) => {
                    return {
                      LotNo: ele.LotNo,
                    };
                  })}
                  exportType="downloadExcel"
                /> */}
                </div>
              </div>
            )}
          </form>

          <div className="row mt-4">
            <div className="col-12">
              {/* <TableComponent
                columns={
                  userRole === "buyer"
                    ? sellProgramsForBuyer.map((obj) => ({
                        ...obj,
                        getCellValue:
                          obj.name === "."
                            ? obj.getCellValue
                            : (row) =>
                                row[obj.name] === null ? "-" : row[obj.name],
                      }))
                    : sellProgramsForAuctioneer.map((obj) => ({
                        ...obj,
                        getCellValue: (row) =>
                          row[obj.name] === null ? "-" : row[obj.name],
                      }))
                }
                rows={rows?.length > 0 ? rows : []}
                setRows={setRows}
                addpagination={true}
                dragdrop={true}
module="pre-auction"
                fixedColumnsOn={false}
                resizeingCol={false}
                selectionCol={true}
                sorting={true}
              /> */}
              <div>Total Count : {rows?.length}</div>

              <div className="TableBox data-table">
                <Grid
                  rows={rows?.length > 0 ? rows : []}
                  columns={
                    userRole === "buyer"
                      ? sellProgramsForBuyer.map((obj) => ({
                          ...obj,
                          getCellValue:
                            obj.name === "."
                              ? obj.getCellValue
                              : (row) =>
                                  row[obj.name] === null
                                    ? "-"
                                    : // : obj.name === "periodOfManufacture"
                                      //   ? newformatDateToDdMmYy(
                                      //     row[obj.name]?.split(" to ")?.at(0)
                                      //   ) +
                                      //   " to " +
                                      //   newformatDateToDdMmYy(
                                      //     row[obj.name]?.split(" to ")?.at(1)
                                      //   )
                                      row[obj.name],
                        }))
                      : sellProgramsForAuctioneer.map((obj) => ({
                          ...obj,
                          getCellValue: (row) =>
                            row[obj.name] === null
                              ? "-"
                              : // : obj.name === "periodOfManufacture"
                                //   ? newformatDateToDdMmYy(
                                //     row[obj.name]?.split(" to ")?.at(0)
                                //   ) +
                                //   " to " +
                                //   newformatDateToDdMmYy(
                                //     row[obj.name]?.split(" to ")?.at(1)
                                //   )
                                row[obj.name],
                        }))
                  }
                >
                  <SortingState />
                  <IntegratedSorting />
                  {/* {userRole === "buyer" ? (
                    <SelectionState
                      selection={selectedDataAuctionCatalogdata}
                      onSelectionChange={setSelectedDataAuctionCatalogdata}
                    />
                  ) : (
                    <SelectionState
                      selection={selectedDataAuctionCatalogdata}
                      onSelectionChange={setSelectedDataAuctionCatalogdata}
                    />
                  )} */}
                  <SelectionState
                    selection={selectedDataAuctionCatalogdata}
                    onSelectionChange={setSelectedDataAuctionCatalogdata}
                    // onSelectionChange={(selection) =>
                    //   setSelectedDataAuctionCatalogdata(selection.length > 0 ? [selection[selection.length - 1]] : [])
                    // }
                  />
                  {/* <PagingState defaultCurrentPage={0} pageSize={rows?.length} /> */}
                  {/* {userRole === "buyer" ? (
                    <IntegratedSelection />
                  ) : (
                    <IntegratedSelection />
                  )} */}
                  <IntegratedSelection />
                  {/* <PagingState defaultCurrentPage={0} />
                  <IntegratedPaging /> */}

                  <DragDropProvider />
                  <VirtualTable height="auto" />
                  <Table messages={tableMessages} />

                  <TableColumnReordering
                    defaultOrder={
                      userRole === "buyer"
                        ? sellProgramsForBuyer
                            .map((obj) => ({
                              ...obj,
                              getCellValue:
                                obj.name === "."
                                  ? obj.getCellValue
                                  : (row) =>
                                      row[obj.name] === null
                                        ? "-"
                                        : // : obj.name === "periodOfManufacture"
                                          //   ? newformatDateToDdMmYy(
                                          //     row[obj.name]?.split(" to ")?.at(0)
                                          //   ) +
                                          //   " to " +
                                          //   newformatDateToDdMmYy(
                                          //     row[obj.name]?.split(" to ")?.at(1)
                                          //   )
                                          row[obj.name],
                            }))
                            ?.map((ele) => ele.name)
                        : sellProgramsForAuctioneer
                            .map((obj) => ({
                              ...obj,
                              getCellValue: (row) =>
                                row[obj.name] === null
                                  ? "-"
                                  : // : obj.name === "periodOfManufacture"
                                    //   ? newformatDateToDdMmYy(
                                    //     row[obj.name]?.split(" to ")?.at(0)
                                    //   ) +
                                    //   " to " +
                                    //   newformatDateToDdMmYy(
                                    //     row[obj.name]?.split(" to ")?.at(1)
                                    //   )
                                    row[obj.name],
                            }))
                            ?.map((ele) => ele.name)
                    }
                  />

                  <TableColumnResizing
                    defaultColumnWidths={
                      userRole === "buyer"
                        ? sellProgramsForBuyer
                            .map((obj) => ({
                              ...obj,
                              getCellValue:
                                obj.name === "."
                                  ? obj.getCellValue
                                  : (row) =>
                                      row[obj.name] === null
                                        ? "-"
                                        : // : obj.name === "periodOfManufacture"
                                          //   ? newformatDateToDdMmYy(
                                          //     row[obj.name]?.split(" to ")?.at(0)
                                          //   ) +
                                          //   " to " +
                                          //   newformatDateToDdMmYy(
                                          //     row[obj.name]?.split(" to ")?.at(1)
                                          //   )
                                          row[obj.name],
                            }))
                            ?.map((ele) => {
                              return { columnName: ele.name, width: 180 };
                            })
                        : sellProgramsForAuctioneer
                            .map((obj) => ({
                              ...obj,
                              getCellValue: (row) =>
                                row[obj.name] === null
                                  ? "-"
                                  : // : obj.name === "periodOfManufacture"
                                    //   ? newformatDateToDdMmYy(
                                    //     row[obj.name]?.split(" to ")?.at(0)
                                    //   ) +
                                    //   " to " +
                                    //   newformatDateToDdMmYy(
                                    //     row[obj.name]?.split(" to ")?.at(1)
                                    //   )
                                    row[obj.name],
                            }))
                            ?.map((ele) => {
                              return { columnName: ele.name, width: 180 };
                            })
                    }
                  />
                  <TableHeaderRow showSortingControls />
                  {/* {userRole === "buyer" ? (
                    <TableSelection
                      showSelectAll
                      selectByRowClick
                      highlightRow
                    />
                  ) : (
                    <TableSelection
                      selectByRowClick
                      highlightRow
                      showSelectionColumn={false}
                    />
                  )} */}

                  <TableSelection
                    showSelectAll={userRole === "buyer"}
                    selectByRowClick
                    highlightRow
                    showSelectionColumn={userRole === "buyer"}
                  />

                  <TableFixedColumns
                    leftColumns={["LotNo"]}
                    rightColumns={[]}
                  />
                  {/* <PagingPanel /> */}
                </Grid>
              </div>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      {userRole === "buyer" ? (
        <div clasName="mt-5 mb-5">
          <ToCreateMyPlanner
            openMyPlanner={openMyPlanner}
            setOpenMyPlanner={setOpenMyPlanner}
            myCatalogDetails={myCatalogRows}
            loggedUser={loggedUser}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            saleProgramId={saleProgramId}
            // myCatalog={() => (
            //   <>
            //     <button
            //       type="button"
            //       className="SubmitBtn"
            //       onClick={() => {
            //         if (userRole === "buyer") {
            //           // axiosMain.post("/preauction/Buyer/AddToMyCatalog")
            //           formik.values.sessionStartTime = timeData
            //             ?.split(" - ")
            //             ?.at(0);
            //           formik.values.sessionEndTime = timeData?.split(" - ")[1];

            //           axiosMain
            //             .post("/preauction/Buyer/GetMyCatalog", {
            //               season: formik.values.season,
            //               saleNo: parseInt(formik.values.saleNo),
            //               auctionDate: formik.values.auctionDate,
            //               buyerId: userId,
            //               // userId: formik.values.auctioneer,
            //               sessionTime: formik.values.sessionTime,
            //               teaTypeId: formik.values.teaType,
            //               categoryId: formik.values.category,
            //               sessionStartTime: formik.values.sessionStartTime,
            //               sessionEndTime: formik.values.sessionEndTime,
            //               auctionCenterId: auctionCenterId,
            //             })
            //             .then((res) => {
            //               if (res.data.statusCode === 200) {
            //                 CustomToast.success(res.data.message);
            //                 setMyCatalogRows(res.data.responseData);
            //                 setSelectedData([]);
            //                 setSelectedDataMyCatalogdata([]);
            //               } else {
            //                 CustomToast.error(res.data.message);
            //                 setMyCatalogRows([]);
            //               }
            //             });

            //           // console.log(KutchaCatalogId);
            //         } else {
            //           if (formik.values.saleNo !== "") {
            //             formik.values.sessionStartTime =
            //               formik.values.sessionTime
            //                 ?.at(0)
            //                 ?.SessionTime?.split(" - ")
            //                 ?.at(0);
            //             formik.values.sessionEndTime = formik.values.sessionTime
            //               ?.at(0)
            //               ?.SessionTime?.split(" - ")[1];
            //             console.log(formik.values);
            //             axiosMain
            //               .post("/preauction/AuctionCatalog/GetMyCatalog", {
            //                 season: formik.values.season,
            //                 saleNo: parseInt(formik.values.saleNo),
            //                 auctionDate: formik.values.auctionDate,
            //                 // auctioneerId: formik.values.auctioneer,

            //                 auctioneerId: userId,
            //                 auctionCenterId: auctionCenterId,
            //                 userId: userId,
            //                 // userId: formik.values.auctioneer,
            //                 teaTypeId: formik.values.teaType,
            //                 categoryId: formik.values.category,
            //                 sessionStartTime: formik.values.sessionStartTime,
            //                 sessionEndTime: formik.values.sessionEndTime,
            //               })
            //               .then((res) => {
            //                 if (res.data.statusCode === 200) {
            //                   CustomToast.success(res.data.message);
            //                   setMyCatalogRows(res.data.responseData);
            //                 } else {
            //                   CustomToast.error(res.data.message);
            //                 }
            //               });
            //           }
            //         }
            //       }}
            //     >
            //       My Catalog
            //     </button>
            //   </>
            // )}
          />
        </div>
      ) : (
        ""
      )}
      <Accordion
        expanded={expandedTab === "panel2" || expandedTab === "All"}
        onChange={handleAccordionChange("panel2")}
        className={`${
          expandedTab === "panel2" || expandedTab === "All" ? "active" : ""
        }`}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>My Catalog</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {/* <div className="BtnGroup">
            <button >
              Create My Planner{" "}
            </button>
          </div> */}

          {userRole === "buyer" ? (
            <div className="BtnGroup d-flex">
              {modalRight?.includes("21") && (
                <button
                  type="button"
                  disable
                  className="SubmitBtn"
                  onClick={() => {
                    setOpenUploadValuation(true);
                  }}
                >
                  Upload Valuation
                </button>
              )}

              {modalRight?.includes("21") && (
                <button
                  disabled={selectedRows.length > 0 ? "" : "disable"}
                  type="button"
                  className="SubmitBtn"
                  onClick={() => {
                    setOpenDelete(true);
                  }}
                >
                  Remove lots
                </button>
              )}

              {/* <button type="button" className="SubmitBtn">
                Save My Catalog
              </button> */}

              {/* <button type="submit" className="SubmitBtn">
            Search
          </button> */}
              <button
                type="button"
                className="SubmitBtn"
                onClick={() => {
                  if (userRole === "buyer") {
                    // axiosMain.post("/preauction/Buyer/AddToMyCatalog")
                    formik.values.sessionStartTime = timeData
                      ?.split(" - ")
                      ?.at(0);
                    formik.values.sessionEndTime = timeData?.split(" - ")[1];
                    let datatime;
                    let sttime;
                    let endtime;
                    if (
                      formik.values.sessionTime !== "" &&
                      formik.values.sessionTime !== undefined
                    ) {
                      datatime = formik.values.sessionTime.split("-");
                      // sttime = datatime[0].slice(0, -5);
                      // endtime = datatime[1].slice(0, -4);
                      sttime = datatime[0].replace(" ", "");
                      endtime = datatime[1].replace(" ", "");
                    } else {
                      sttime = "";
                      endtime = "";
                    }
                    openLoader();
                    axiosMain
                      .post(
                        `/preauction/${auctionCatalogUrl}/GetMyCatalog?role=` +
                          loggedUser?.userCode,
                        // auctionCatalogUrl === "Buyer"
                        //   ? {
                        //     season: formik.values.season,
                        //     saleNo: parseInt(formik.values.saleNo),
                        //     auctionDate: formik.values.auctionDate,
                        //     buyerId: userId,
                        //     // userId: formik.values.auctioneer,
                        //     sessionTime: formik.values.sessionTime,
                        //     teaTypeId:
                        //       teatypeList.filter(
                        //         (ele) =>
                        //           ele.teaTypeId ===
                        //           parseInt(formik.values.teaType)
                        //       )[0]?.teaTypeName === "BOTH"
                        //         ? 0
                        //         : parseInt(formik.values.teaType),
                        //     categoryId: formik.values.category,
                        //     sessionStartTime: sttime,
                        //     sessionEndTime: endtime,
                        //     auctionCenterId: auctionCenterId,
                        //   }
                        //   :
                        {
                          season: formik.values.season,
                          saleNo: parseInt(formik.values.saleNo),
                          auctionDate: formik.values.auctionDate,
                          buyerId: userId,
                          // userId: formik.values.auctioneer,
                          sessionTime: formik.values.sessionTime,
                          teaTypeId: formik.values.teaType,
                          categoryId: formik.values.category,
                          sessionStartTime: formik.values.sessionStartTime,
                          sessionEndTime: formik.values.sessionEndTime,
                          auctionCenterId: auctionCenterId,
                          gradeId:
                            formik.values.grade === "" ||
                            formik.values.grade === undefined
                              ? 0
                              : parseInt(formik.values.grade),
                          markId:
                            formik.values.mark === "" ||
                            formik.values.mark === undefined
                              ? 0
                              : parseInt(formik.values.mark),
                          origin: formik.values.origin
                            ? formik.values.origin
                            : "",
                        }
                      )
                      .then((res) => {
                        if (res.data.statusCode === 200) {
                          CustomToast.success(res.data.message);

                          let data = res.data?.responseData?.map((ele) => {
                            return {
                              ...ele,
                              gpDate: formatDateToDdMmYy(ele.gpDate),
                              auctionDate: formatDateToDdMmYy(ele.auctionDate),
                            };
                          });

                          setMyCatalogRows(data);
                          setSelectedData([]);
                          setSelectedDataMyCatalogdata([]);
                          setSelectedRows([]);
                          //set session type id
                          setsessionTypeId(
                            res.data?.responseData[0]?.sessionTypeId
                          );
                        } else {
                          CustomToast.error(res.data.message);
                          setMyCatalogRows([]);
                        }
                        closeLoader();
                      });

                    // console.log(KutchaCatalogId);
                  } else {
                    if (formik.values.saleNo !== "") {
                      formik.values.sessionStartTime = formik.values.sessionTime
                        ?.at(0)
                        ?.SessionTime?.split(" - ")
                        ?.at(0);
                      formik.values.sessionEndTime = formik.values.sessionTime
                        ?.at(0)
                        ?.SessionTime?.split(" - ")[1];
                      console.log(formik.values);

                      let datatime;
                      let sttime;
                      let endtime;
                      if (
                        formik.values.sessionTime !== "" &&
                        formik.values.sessionTime !== undefined
                      ) {
                        datatime = formik.values.sessionTime.split("-");
                        // sttime = datatime[0].slice(0, -5);
                        // endtime = datatime[1].slice(0, -4);
                        sttime = datatime[0].replace(" ", "");
                        endtime = datatime[1].replace(" ", "");
                      } else {
                        sttime = "";
                        endtime = "";
                      }
                      openLoader();

                      axiosMain
                        .post(
                          `/preauction/${auctionCatalogUrl}/GetMyCatalog?role=` +
                            loggedUser?.userCode,
                          {
                            season: formik.values.season,
                            saleNo: parseInt(formik.values.saleNo),
                            auctionDate: formik.values.auctionDate,
                            // auctioneerId: formik.values.auctioneer,

                            auctioneerId: userId,
                            auctionCenterId: auctionCenterId,
                            userId: userId,
                            // userId: formik.values.auctioneer,
                            teaTypeId:
                              teatypeList.filter(
                                (ele) =>
                                  ele.teaTypeId ===
                                  parseInt(formik.values.teaType)
                              )[0]?.teaTypeName === "BOTH"
                                ? 0
                                : parseInt(formik.values.teaType),
                            categoryId: formik.values.category,
                            sessionStartTime: sttime,
                            sessionEndTime: endtime,
                          }
                        )
                        .then((res) => {
                          if (res.data.statusCode === 200) {
                            CustomToast.success(res.data.message);
                            let data = res.data?.responseData?.map((ele) => {
                              return {
                                ...ele,
                                saleDate: formatDateToDdMmYy(ele.saleDate),
                                gpDate: formatDateToDdMmYy(ele.gpDate),
                              };
                            });
                            setMyCatalogRows(data);
                          } else {
                            CustomToast.error(res.data.message);
                          }
                          closeLoader();
                        });
                    }
                  }
                }}
              >
                Get My Catalog
              </button>

              {modalRight?.includes("42") && (
                <button
                  type="submit"
                  className="SubmitBtn"
                  onClick={() => setOpenMyPlanner(true)}
                  disabled={myCatalogRows.length > 0 ? false : true}
                >
                  Create My Planner
                </button>
              )}

              {modalRight?.includes("9") && (
                <>
                  <Tooltip title="Print">
                    <button
                      className="Excel"
                      onClick={handleExportToPdfMyCatalog}
                    >
                      <i className="fa fa-print"></i>
                    </button>
                  </Tooltip>

                  <Tooltip title="Export as Excel">
                    <button
                      type="button"
                      className="Excel"
                      onClick={handleExportExcelMyCatalog}
                    >
                      <i className="fa fa-file-excel"></i>
                    </button>
                  </Tooltip>

                  <ExportPDF
                    columns={
                      exportColumns
                      // userRole?.toLowerCase() === "auctioneer" ||
                      //   userRole?.toLowerCase() === "teaboard"
                      //   ? [...myCatalogForAuctioneer, { title: "Auctioner Code", name: "auctioneerCode" }]
                      //   : [...myCatalogForBuyer, { title: "Auctioner Code", name: "auctioneerCode" }]
                    }
                    data={myCatalogRows?.length > 0 ? myCatalogRows : []}
                    name={"MyCatalog"}
                    auctionType={
                      userRole === "buyer"
                        ? auctionCatalogUrl === "EnglishAuctionBuyer"
                          ? "ENGLISH"
                          : "BHARAT"
                        : auctionCatalogUrl === "EnglishAuctionCatalog"
                        ? "ENGLISH"
                        : "BHARAT"
                    }
                  />

                  <ExportHTMl
                    columns={
                      exportColumnsmyCatalog
                      // userRole?.toLowerCase() === "auctioneer" ||
                      //   userRole?.toLowerCase() === "teaboard"
                      //   ? [...myCatalogForAuctioneer, { title: "Auctioner Code", name: "auctioneerCode" }]
                      //   : [...myCatalogForBuyer, { title: "Auctioner Code", name: "auctioneerCode" }]
                    }
                    data={myCatalogRows?.length > 0 ? myCatalogRows : []}
                    name={"MyCatalog"}
                  />
                </>
              )}
            </div>
          ) : (
            <div className="BtnGroup d-flex">
              {/* {modalRight?.includes("9") && (
                <button
                  type="button"
                  className="SubmitBtn"
                  onClick={handleExportExcelMyCatalog}
                >
                  Export My Catalog
                </button>
              )} */}
              {/* {modalRight?.includes("9") && (
                <button
                  type="button"
                  onClick={() =>
                    PrintableTable(
                      userRole?.toLowerCase() === "auctioneer" ||
                        userRole?.toLowerCase() === "teaboard"
                        ? myCatalogForAuctioneer
                        : myCatalogForBuyer,
                      myCatalogRows?.length > 0 ? myCatalogRows : [],
                      userRole + "My Catalog"
                    )
                  }
                  className="SubmitBtn"
                >
                  Print My Catalog
                </button>
              )} */}
              {modalRight?.includes("21") && (
                <button
                  type="button"
                  disable
                  className="SubmitBtn"
                  onClick={() => {
                    setOpenUploadValuation(true);
                  }}
                >
                  Upload Valuation
                </button>
              )}
              {modalRight?.includes("26") && (
                <button
                  type="button"
                  className="SubmitBtn"
                  onClick={() => {
                    if (userRole === "buyer") {
                      // axiosMain.post("/preauction/Buyer/AddToMyCatalog")
                      formik.values.sessionStartTime = timeData
                        ?.split(" - ")
                        ?.at(0);
                      formik.values.sessionEndTime = timeData?.split(" - ")[1];
                      let datatime;
                      let sttime;
                      let endtime;
                      if (
                        formik.values.sessionTime !== "" &&
                        formik.values.sessionTime !== undefined
                      ) {
                        datatime = formik.values.sessionTime.split("-");
                        // sttime = datatime[0].slice(0, -5);
                        // endtime = datatime[1].slice(0, -4);
                        sttime = datatime[0].replace(" ", "");
                        endtime = datatime[1].replace(" ", "");
                      } else {
                        sttime = "";
                        endtime = "";
                      }
                      axiosMain
                        .post(
                          `/preauction/${auctionCatalogUrl}/GetMyCatalog?role=` +
                            loggedUser?.userCode,
                          // auctionCatalogUrl === "Buyer"
                          //   ? {
                          //     season: formik.values.season,
                          //     saleNo: parseInt(formik.values.saleNo),
                          //     auctionDate: formik.values.auctionDate,
                          //     buyerId: userId,
                          //     // userId: formik.values.auctioneer,
                          //     sessionTime: formik.values.sessionTime,
                          //     teaTypeId:
                          //       teatypeList.filter(
                          //         (ele) =>
                          //           ele.teaTypeId ===
                          //           parseInt(formik.values.teaType)
                          //       )[0]?.teaTypeName === "BOTH"
                          //         ? 0
                          //         : parseInt(formik.values.teaType),
                          //     categoryId: formik.values.category,
                          //     sessionStartTime: sttime,
                          //     sessionEndTime: endtime,
                          //     auctionCenterId: auctionCenterId,
                          //   }
                          //   :
                          {
                            season: formik.values.season,
                            saleNo: parseInt(formik.values.saleNo),
                            auctionDate: formik.values.auctionDate,
                            buyerId: userId,
                            // userId: formik.values.auctioneer,
                            sessionTime: formik.values.sessionTime,
                            teaTypeId:
                              teatypeList.filter(
                                (ele) =>
                                  ele.teaTypeId ===
                                  parseInt(formik.values.teaType)
                              )[0]?.teaTypeName === "BOTH"
                                ? 0
                                : parseInt(formik.values.teaType),
                            categoryId: formik.values.category,
                            sessionStartTime: formik.values.sessionStartTime,
                            sessionEndTime: formik.values.sessionEndTime,
                            auctionCenterId: auctionCenterId,
                            gradeId:
                              formik.values.grade === "" ||
                              formik.values.grade === undefined
                                ? 0
                                : parseInt(formik.values.grade),
                            markId:
                              formik.values.mark === "" ||
                              formik.values.mark === undefined
                                ? 0
                                : parseInt(formik.values.mark),
                            origin: formik.values.origin
                              ? formik.values.origin
                              : "",
                          }
                        )
                        .then((res) => {
                          if (res.data.statusCode === 200) {
                            CustomToast.success(res.data.message);
                            setMyCatalogRows(res.data.responseData);
                            setSelectedData([]);
                            setSelectedDataMyCatalogdata([]);
                            setSelectedRows([]);
                            //set session type id
                            setsessionTypeId(
                              res.data?.responseData[0]?.sessionTypeId
                            );
                          } else {
                            CustomToast.error(res.data.message);
                            setMyCatalogRows([]);
                          }
                        });

                      // console.log(KutchaCatalogId);
                    } else {
                      if (formik.values.saleNo !== "") {
                        // formik.values.sessionStartTime =
                        //   formik.values.sessionTime
                        //     ?.at(0)
                        //     ?.SessionTime?.split(" - ")
                        //     ?.at(0);
                        // formik.values.sessionEndTime = formik.values.sessionTime
                        //   ?.at(0)
                        //   ?.SessionTime?.split(" - ")[1];

                        let datatime;
                        let sttime;
                        let endtime;
                        if (
                          formik.values.sessionTime !== "" &&
                          formik.values.sessionTime !== undefined
                        ) {
                          datatime = formik.values.sessionTime.split("-");
                          // sttime = datatime[0].slice(0, -5);
                          // endtime = datatime[1].slice(0, -4);
                          sttime = datatime[0].replace(" ", "");
                          endtime = datatime[1].replace(" ", "");
                        } else {
                          sttime = "";
                          endtime = "";
                        }
                        openLoader();
                        console.log(formik.values);
                        axiosMain
                          .post(
                            `/preauction/${auctionCatalogUrl}/GetMyCatalog?role=` +
                              loggedUser?.userCode,
                            {
                              // axios
                              // .post(
                              //   "http://192.168.101.221:5080/preauction/AuctionCatalog/GetMyCatalog?role=" +
                              //     loggedUser?.userCode,
                              //   {
                              season: formik.values.season,
                              saleNo: parseInt(formik.values.saleNo),
                              auctionDate: formik.values.auctionDate,
                              // auctioneerId: formik.values.auctioneer,

                              auctioneerId: userId,
                              auctionCenterId: auctionCenterId,
                              userId: userId,
                              // userId: formik.values.auctioneer,
                              teaTypeId:
                                teatypeList.filter(
                                  (ele) =>
                                    ele.teaTypeId ===
                                    parseInt(formik.values.teaType)
                                )[0]?.teaTypeName === "BOTH"
                                  ? 0
                                  : parseInt(formik.values.teaType),
                              categoryId: formik.values.category,
                              sessionStartTime: sttime,
                              sessionEndTime: endtime,
                            }
                          )
                          .then((res) => {
                            if (res.data.statusCode === 200) {
                              CustomToast.success(res.data.message);
                              let data = res.data?.responseData?.map((ele) => {
                                return {
                                  ...ele,
                                  saleDate: formatDateToDdMmYy(ele.saleDate),
                                  gpDate: formatDateToDdMmYy(ele.gpDate),
                                };
                              });
                              setMyCatalogRows(data);
                            } else {
                              CustomToast.error(res.data.message);
                            }
                            closeLoader();
                          });
                      }
                    }
                  }}
                >
                  Get My Catalog
                </button>
              )}
              {/* <button
                className="SubmitBtn"
                onClick={handleExportToPdfMyCatalog}
              >
                Print
              </button> */}
              {modalRight?.includes("9") && (
                <>
                  <Tooltip title="Print">
                    <button
                      className="Excel"
                      onClick={handleExportToPdfMyCatalog}
                    >
                      <i className="fa fa-print"></i>
                    </button>
                  </Tooltip>

                  <Tooltip title="Export as Excel">
                    <button
                      type="button"
                      className="Excel"
                      onClick={handleExportExcelMyCatalog}
                    >
                      <i className="fa fa-file-excel"></i>
                    </button>
                  </Tooltip>

                  <ExportPDF
                    columns={
                      exportColumnsmyCatalog
                      // userRole?.toLowerCase() === "auctioneer" ||
                      //   userRole?.toLowerCase() === "teaboard"
                      //   ? [...myCatalogForAuctioneer, { title: "Auctioner Code", name: "auctioneerCode" }]
                      //   : [...myCatalogForBuyer, { title: "Auctioner Code", name: "auctioneerCode" }]
                    }
                    data={myCatalogRows?.length > 0 ? myCatalogRows : []}
                    name={"MyCatalog"}
                    auctionType={
                      userRole === "buyer"
                        ? auctionCatalogUrl === "EnglishAuctionBuyer"
                          ? "ENGLISH"
                          : "BHARAT"
                        : auctionCatalogUrl === "EnglishAuctionCatalog"
                        ? "ENGLISH"
                        : "BHARAT"
                    }
                  />

                  <ExportHTMl
                    columns={
                      exportColumnsmyCatalog
                      // userRole?.toLowerCase() === "auctioneer" ||
                      //   userRole?.toLowerCase() === "teaboard"
                      //   // ?myCatalogForAuctioneer:myCatalogForBuyer
                      //   ? [...myCatalogForAuctioneer, { title: "Auctioner Code", name: "auctioneerCode" }]
                      //   : [...myCatalogForBuyer, { title: "Auctioner Code", name: "auctioneerCode" }]
                    }
                    data={myCatalogRows?.length > 0 ? myCatalogRows : []}
                    name={"MyCatalog"}
                  />
                </>

                // <ExportPDF
                //   columns={
                //     userRole?.toLowerCase() === "auctioneer" ||
                //     userRole?.toLowerCase() === "teaboard"
                //       ? myCatalogForAuctioneer
                //       : myCatalogForBuyer
                //   }
                //   data={myCatalogRows?.length > 0 ? myCatalogRows : []}
                //   name={"MyCatalog"}
                //   buttonName="Export My Catalog"
                // />
              )}
              {/* <button type="button" className="SubmitBtn">
                Save
              </button> */}
            </div>
          )}
          <div className="row mt-4">
            <div
              className="col-12"
              style={{ maxHeight: "72vh" }}
              id="table-content"
            >
              {/* <TableComponent
                columns={
                  userRole?.toLowerCase() === "auctioneer" ||
                  userRole?.toLowerCase() === "teaboard"
                    ? myCatalogForAuctioneer.map((obj) => ({
                        ...obj,
                        getCellValue: (row) =>
                          obj.name === "action" ? (
                            <>
                              <button
                                type="button"
                                onClick={() => {
                                  setOpenUploadUpdateValuation(true);
                                  axiosMain
                                    .post(
                                      "/preauction/AuctionCatalog/GetMyCatalogValuationByParam",
                                      {
                                        auctionCatalogId: row.auctionCatalogId,
                                        auctioneerId: userId,
                                        auctionCenterId: auctionCenterId,
                                        season: row.Season,
                                        saleNo: row.saleNo,
                                      }
                                    )
                                    .then((res) => {
                                      setGetDataByprems(res.data.responseData);
                                    });
                                }}
                              >
                                <i className="fa fa-edit"></i>
                              </button>
                              {/* <button type="button" onClick={() => setOpenMyPlanner(true)}>
                                  Add Valuation
                                </button> 
                            </>
                          ) : row[obj.name] === null ? (
                            "-"
                          ) : (
                            row[obj.name]
                          ),
                      }))
                    : myCatalogForBuyer.map((obj) => ({
                        ...obj,
                        getCellValue:
                          obj.name === "."
                            ? obj.getCellValue
                            : (row) =>
                                obj.name === "action"
                                  ? row[obj.name]
                                  : row[obj.name] === null
                                  ? "-"
                                  : row[obj.name],
                      }))
                }
                rows={myCatalogRows?.length > 0 ? myCatalogRows : []}
                setRows={setMyCatalogRows}
                addpagination={true}
                dragdrop={true}
module="pre-auction"
                fixedColumnsOn={false}
                resizeingCol={false}
                selectionCol={true}
                sorting={true}
              /> */}
              <div>Total Count : {myCatalogRows?.length}</div>

              {/* <table border="1" cellPadding="5" cellSpacing="0">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      </th>
                      {myCatalogForBuyer?.map((col) => (
                        <th key={col.name}>{col.title}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {myCatalogRows.length > 0 &&
                      myCatalogRows.map((row) => (
                        <tr key={row.MyCatalogId}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(row.MyCatalogId)}
                              onChange={() => handleSelectRow(row.MyCatalogId)}
                            />
                          </td>
                          {myCatalogForBuyer.map((col) => (
                            <td key={col.name}
                              onClick={() => setEditableCell({ rowId: row.MyCatalogId, columnName: col.name })}
                            >
                              {col.name === "myValuation" ? (
                                editableCell.rowId === row.MyCatalogId && editableCell.columnName === col.name ? (
                                  <input
                                    type="number"
                                    autoFocus
                                    value={valuationMap[row.MyCatalogId] ?? row.myValuation}
                                    onChange={(e) => { handleValuationChange(e.target.value, row.MyCatalogId, col.name); }
                                    }
                                    onBlur={() => setEditableCell({ rowId: null, columnName: null })}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        commitChanges(row, e.target.value, row.MyCatalogId)
                                      }
                                    }}
                                  />
                                ) : (
                                  <span
                                    className="w-100"
                                  >
                                    {valuationMap[row.MyCatalogId] > 0
                                      ? valuationMap[row.MyCatalogId]
                                      : row.myValuation > 0
                                        ? row.myValuation
                                        : 0}
                                  </span>
                                )
                              ) :
                                col.name === "myComments" ? (
                                  editableCell.rowId === row.MyCatalogId && editableCell.columnName === col.name ? (
                                    <input
                                      type="text"
                                      autoFocus
                                      value={valuationMap[row.MyCatalogId] ?? row.myComments}
                                      onChange={(e) => { handleValuationChange(e.target.value, row.MyCatalogId, col.name); }
                                      }
                                      onBlur={() => setEditableCell({ rowId: null, columnName: null })}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          commitChanges(row, e.target.value, row.MyCatalogId)
                                        }
                                      }}
                                    />
                                  ) : (
                                    <span
                                      className="w-100"

                                    >{row.myComments === null ? "-" : row.myComments}
                                    </span>
                                  )
                                )

                                  : col.name === "action" ? (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setOpenUploadUpdateValuation(true);
                                        setauctioncatalogIdforupload(row.KutchaCatalogId);
                                        setGetDataByprems(row);
                                      }}
                                    >
                                      <i className="fa fa-edit"></i>
                                    </button>
                                  ) : (
                                    row[col.name] === null
                                      ? "-" : row[col.name]
                                  )}
                            </td>
                          ))}
                        </tr>
                      ))}
                  </tbody>
                </table> */}
              <div
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: "400px",
                  maxWidth: "100%",
                  border: "1px solid #ccc",
                  whiteSpace: "nowrap",
                }}
                ref={tableRef}
                className="TableBox normal-table"
              >
                <table
                  className="resizable-columns-table"
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    minWidth: "600px",
                  }}
                >
                  <thead>
                    <tr>
                      {userRole === "buyer" && (
                        <th
                          style={{
                            position: "sticky",
                            left: 0,
                            background: "#f0f0f0",
                            zIndex: 10,
                            borderRight: "1px solid #ddd",
                            padding: "10px",
                            resize: "none",
                            width: "35px",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                        </th>
                      )}
                      <th
                        style={{
                          position: "sticky",
                          background: "#f0f0f0",
                          left: userRole !== "buyer" ? "0px" : "30px",
                          zIndex: 10,
                          borderRight: "1px solid #ddd",
                          padding: "10px",
                          resize: "none",
                          width: "340px",
                        }}
                      >
                        Lot No.
                      </th>
                      {["auctioneer", "teaboard", "taouser"].includes(
                        userRole?.toLowerCase()
                      )
                        ? myCatalogForAuctioneer?.map((col, index) => (
                            <th
                              key={col.name}
                              draggable
                              onDragStart={(e) => handleDragStart(e, index)}
                              onDragOver={handleDragOver}
                              onDrop={(e) =>
                                handleDrop(
                                  e,
                                  index,
                                  myCatalogForAuctioneer,
                                  setMyCatalogForAuctioneer
                                )
                              }
                              style={{ width: "200px" }}
                            >
                              <div className="resizable-columns">
                                {col.title}
                              </div>
                            </th>
                          ))
                        : myCatalogForBuyer?.map((col, index) => (
                            <th
                              key={col.name}
                              draggable
                              onDragStart={(e) => handleDragStart(e, index)}
                              onDragOver={handleDragOver}
                              onDrop={(e) =>
                                handleDrop(
                                  e,
                                  index,
                                  myCatalogForBuyer,
                                  setMyCatalogForBuyer
                                )
                              }
                              style={{ width: "200px" }}
                            >
                              <div className="resizable-columns">
                                {col.title}
                              </div>
                            </th>
                          ))}
                    </tr>
                  </thead>
                  <tbody>
                    {["auctioneer", "teaboard", "taouser"].includes(
                      userRole?.toLowerCase()
                    ) ? (
                      myCatalogRows?.length > 0 ? (
                        myCatalogRows.map((row, index) => (
                          <tr
                            onDoubleClick={() =>
                              fnGetMyCatalogValuationByParam(row)
                            }
                            key={row.auctionCatalogId}
                            onClick={() => handleRowClickchangeColor(index)}
                            style={{
                              backgroundColor:
                                rowColorchange === index
                                  ? "#f0f0f0"
                                  : "transparent",
                              cursor: "pointer",
                            }}
                          >
                            <td
                              style={{
                                position: "sticky",
                                left: userRole !== "buyer" ? "0px" : "30px",
                                background: "#f0f0f0",
                                zIndex: 10,
                                borderRight: "1px solid #ddd",
                                padding: "10px",
                                resize: "none",
                                width: "340px",
                              }}
                            >
                              {row.LotNo}
                            </td>
                            {myCatalogForAuctioneer?.map((col) => (
                              <td
                                key={col.name}
                                onClick={() =>
                                  setEditableCell({
                                    rowId: row.auctionCatalogId,
                                    columnName: col.name,
                                  })
                                }
                              >
                                {col.name === "markName" ? (
                                  editableCell.rowId === row.auctionCatalogId &&
                                  editableCell.columnName === col.name ? (
                                    <select
                                      ref={(el) =>
                                        (selectRefs.current[index] = el)
                                      }
                                      defaultValue={row[col.name] ?? ""}
                                      // onBlur={() =>
                                      //   setEditableCell({
                                      //     rowId: null,
                                      //     columnName: null,
                                      //   })
                                      // }
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          commitChanges(
                                            row,
                                            e.target.value,
                                            row.auctionCatalogId,
                                            col.name,
                                            index
                                          );
                                          if (
                                            myCatalogRows.length ===
                                            index + 1
                                          ) {
                                            setEditableCell({});
                                          } else {
                                            setEditableCell({
                                              rowId:
                                                myCatalogRows[index + 1]
                                                  .auctionCatalogId,
                                              columnName: col.name,
                                            });
                                          }

                                          //   setEditableCell({
                                          //     rowId:
                                          //       myCatalogRows[index + 1]
                                          //         .auctionCatalogId,
                                          //     columnName: col.name,
                                          //   });
                                        }
                                      }}
                                      // onChange={(e) =>
                                      //   commitChanges(
                                      //     row,
                                      //     e.target.value,
                                      //     row.MyCatalogId,
                                      //     col.name
                                      //   )
                                      // }
                                      onFocus={(e) => (e.target.value = "")}
                                    >
                                      <option value="">Select Mark</option>

                                      {markDataList?.length > 0
                                        ? markDataList?.map((item, index) => (
                                            <option
                                              value={item.markCode}
                                              key={index}
                                            >
                                              {item.markCode}
                                            </option>
                                          ))
                                        : "No Data"}
                                    </select>
                                  ) : (
                                    <span>{row.markName}</span>
                                  )
                                ) : [
                                    "auctioneerValuation",
                                    "grossKgs",
                                    "basePrice",
                                    "reservePrice",
                                    "SampleQty",
                                    "tareKgs",
                                    "ShortExcessWeight",
                                    baseUrlEng === "AuctionCatalog"
                                      ? "totalPackages"
                                      : "",
                                    baseUrlEng === "EnglishAuctionCatalog"
                                      ? ""
                                      : "priceIncrement",
                                    baseUrlEng === "EnglishAuctionCatalog"
                                      ? ""
                                      : "ageOfProducts",
                                    baseUrlEng === "EnglishAuctionCatalog"
                                      ? "totalPackages"
                                      : "",
                                    // baseUrlEng === "EnglishAuctionCatalog"
                                    //   ? "tareKgs"
                                    //   : ""
                                    ,
                                  ].includes(col.name) ? (
                                  editableCell.rowId === row.auctionCatalogId &&
                                  editableCell.columnName === col.name ? (
                                    <input
                                      ref={(el) =>
                                        (inputRefs.current[index] = el)
                                      }
                                      type="number"
                                      autoFocus
                                      defaultValue={row[col.name] ?? ""}
                                      // onBlur={() =>
                                      //   setEditableCell({
                                      //     rowId: null,
                                      //     columnName: null,
                                      //   })

                                      // }
                                      disabled={(() => {
                                        if (
                                          baseUrlEng === "EnglishAuctionCatalog"
                                        ) {
                                          if (row?.isEditable === 0)
                                            return true;
                                          if (
                                            row?.hours_date_difference < 24 &&
                                            col.name === "reservePrice"
                                          )
                                            return false;
                                          return (
                                            row?.hours_date_difference < 24
                                          );
                                        } else {
                                          if (
                                            row?.hours_date_difference < 48 &&
                                            row?.minute_difference >= 15 &&
                                            col.name === "reservePrice"
                                          )
                                            return false;
                                          return (
                                            row?.hours_date_difference < 48
                                          );
                                        }
                                      })()}
                                      onKeyDown={async (e) => {
                                        if (e.key === "Enter") {
                                          if (
                                            myCatalogRows.length ===
                                            index + 1
                                          ) {
                                            setEditableCell({});
                                          } else {
                                            setEditableCell({
                                              rowId:
                                                myCatalogRows[index + 1]
                                                  .auctionCatalogId,
                                              columnName: col.name,
                                            });
                                          }

                                          commitChanges(
                                            row,
                                            e.target.value,
                                            row.auctionCatalogId,
                                            col.name,
                                            index
                                          );
                                        }
                                      }}
                                      onFocus={(e) => (e.target.value = "")}
                                    />
                                  ) : (
                                    <span>{row[col.name] ?? "-"}</span>
                                  )
                                ) : [
                                    "markPackageComments",
                                    "lotComments",
                                    baseUrlEng === "AuctionCatalog"
                                      ? "packageNo"
                                      : "",
                                    baseUrlEng === "EnglishAuctionCatalog"
                                      ? "packageNo"
                                      : "",
                                    "qualityComments",
                                    baseUrlEng === "EnglishAuctionCatalog"
                                      ? ""
                                      : "gardenCertification",
                                    "qualityCertification",
                                    "brewColor",
                                    baseUrlEng === "EnglishAuctionCatalog"
                                      ? ""
                                      : "brewersComments",
                                    // baseUrlEng === "EnglishAuctionCatalog"
                                    //   ? "categoryName"
                                    //   : "",
                                    // baseUrlEng === "EnglishAuctionCatalog"
                                    //   ? "shortExcessWeight"
                                    //   : "",
                                  ].includes(col.name) ? (
                                  editableCell.rowId === row.auctionCatalogId &&
                                  editableCell.columnName === col.name ? (
                                    <input
                                      ref={(el) =>
                                        (inputRefs.current[index] = el)
                                      }
                                      type="text"
                                      autoFocus
                                      defaultValue={row[col.name] ?? "-"}
                                      // onBlur={() =>
                                      //   setEditableCell({
                                      //     rowId: null,
                                      //     columnName: null,
                                      //   })
                                      // }
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          if (
                                            myCatalogRows.length ===
                                            index + 1
                                          ) {
                                            setEditableCell({});
                                          } else {
                                            setEditableCell({
                                              rowId:
                                                myCatalogRows[index + 1]
                                                  .auctionCatalogId,
                                              columnName: col.name,
                                            });
                                          }

                                          // setEditableCell({
                                          //   rowId:
                                          //     myCatalogRows[index + 1]
                                          //       .auctionCatalogId,
                                          //   columnName: col.name,
                                          // });
                                          commitChanges(
                                            row,
                                            e.target.value,
                                            row.auctionCatalogId,
                                            col.name,
                                            index
                                          );
                                        }
                                      }}
                                      disabled={(() => {
                                        if (
                                          baseUrlEng === "EnglishAuctionCatalog"
                                        ) {
                                          if (row?.isEditable === 0)
                                            return true;
                                          if (
                                            row?.hours_date_difference < 24 &&
                                            col.name === "reservePrice"
                                          )
                                            return false;
                                          return (
                                            row?.hours_date_difference < 24
                                          );
                                        } else {
                                          if (
                                            row?.hours_date_difference < 48 &&
                                            row?.minute_difference >= 15 &&
                                            col.name === "reservePrice"
                                          )
                                            return false;
                                          return (
                                            row?.hours_date_difference < 48
                                          );
                                        }
                                      })()}
                                      onFocus={(e) => (e.target.value = "")}
                                    />
                                  ) : (
                                    <span>{row[col.name] ?? "-"}</span>
                                  )
                                ) : col.name === "action" ? (
                                  <>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        fnGetMyCatalogValuationByParam(row)
                                      }
                                    >
                                      <i class="fa fa-edit"></i>
                                    </button>
                                  </>
                                ) : row[col.name] === null ? (
                                  "-"
                                ) : (
                                  row[col.name]
                                )}
                              </td>
                            ))}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={53}>
                            <div className="NoData">No Records Found</div>
                          </td>
                        </tr>
                      )
                    ) : myCatalogRows.length > 0 ? (
                      myCatalogRows.map((row, index) => (
                        <tr
                          onDoubleClick={() => {
                            setOpenUploadUpdateValuation(true);
                            setauctioncatalogIdforupload(row.KutchaCatalogId);
                            setGetDataByprems(row);
                          }}
                          key={row.MyCatalogId}
                          onClick={() => handleRowClickchangeColor(index)}
                          style={{
                            backgroundColor:
                              rowColorchange === index
                                ? "#f0f0f0"
                                : "transparent",
                            cursor: "pointer",
                          }}
                        >
                          <td
                            style={{
                              position: "sticky",
                              left: 0,
                              background: "#f0f0f0",
                              zIndex: 10,
                              borderRight: "1px solid #ddd",
                              // padding: "10px",
                              paddingLeft: "9px",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(row.MyCatalogId)}
                              onChange={() => handleSelectRow(row.MyCatalogId)}
                            />
                          </td>
                          <td
                            style={{
                              position: "sticky",
                              background: "#f0f0f0",
                              left: userRole !== "buyer" ? "0px" : "30px",
                              zIndex: 10,
                              borderRight: "1px solid #ddd",
                              padding: "10px",
                              resize: "none",
                              width: "340px",
                            }}
                          >
                            {row.lotNo}
                          </td>
                          {myCatalogForBuyer.map((col) => (
                            <td
                              key={col.name}
                              onClick={() =>
                                setEditableCell({
                                  rowId: row.MyCatalogId,
                                  columnName: col.name,
                                })
                              }
                            >
                              {col.name === "myValuation" ||
                              col.name === "myComments" ? (
                                editableCell.rowId === row.MyCatalogId &&
                                editableCell.columnName === col.name ? (
                                  <input
                                    ref={(el) =>
                                      (inputRefs.current[index] = el)
                                    }
                                    type={
                                      col.name === "myValuation"
                                        ? "number"
                                        : "text"
                                    }
                                    autoFocus
                                    defaultValue={
                                      col.name === "myValuation"
                                        ? row.myValuation
                                        : row.myComments
                                    }
                                    // onChange={(e) => { handleValuationChange(e.target.value, row.MyCatalogId, col.name); }}
                                    // onBlur={() =>
                                    //   setEditableCell({
                                    //     rowId: null,
                                    //     columnName: null,
                                    //   })
                                    // }
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        if (
                                          myCatalogRows.length ===
                                          index + 1
                                        ) {
                                          setEditableCell({});
                                        } else {
                                          setEditableCell({
                                            rowId:
                                              myCatalogRows[index + 1]
                                                .MyCatalogId,
                                            columnName: col.name,
                                          });
                                        }

                                        commitChanges(
                                          row,
                                          e.target.value,
                                          row.MyCatalogId,
                                          col.name,
                                          index
                                        );
                                        // setEditableCell({
                                        //   rowId:
                                        //     myCatalogRows[index + 1]
                                        //       .MyCatalogId,
                                        //   columnName: col.name,
                                        // });
                                      }
                                    }}
                                    onFocus={(e) => (e.target.value = "")}
                                  />
                                ) : (
                                  <span>
                                    {col.name === "myValuation"
                                      ? row.myValuation ?? 0
                                      : row.myComments ?? "-"}
                                  </span>
                                )
                              ) : col.name === "groupCode" ? (
                                editableCell.rowId === row.MyCatalogId &&
                                editableCell.columnName === col.name ? (
                                  <select
                                    ref={(el) =>
                                      (selectRefs.current[index] = el)
                                    }
                                    defaultValue={row.groupCode || ""}
                                    // onBlur={() =>
                                    //   setEditableCell({
                                    //     rowId: null,
                                    //     columnName: null,
                                    //   })
                                    // }
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        commitChanges(
                                          row,
                                          e.target.value,
                                          row.MyCatalogId,
                                          col.name,
                                          index
                                        );
                                        if (
                                          myCatalogRows.length ===
                                          index + 1
                                        ) {
                                          setEditableCell({});
                                        } else {
                                          setEditableCell({
                                            rowId:
                                              myCatalogRows[index + 1]
                                                .MyCatalogId,
                                            columnName: col.name,
                                          });
                                        }
                                        // setEditableCell({
                                        //   rowId:
                                        //     myCatalogRows[index + 1]
                                        //       .MyCatalogId,
                                        //   columnName: col.name,
                                        // });
                                      }
                                    }}
                                    // onChange={(e) =>
                                    //   commitChanges(
                                    //     row,
                                    //     e.target.value,
                                    //     row.MyCatalogId,
                                    //     col.name
                                    //   )
                                    // }
                                    onFocus={(e) => (e.target.value = "")}
                                  >
                                    <option value="">Select Group</option>
                                    {groupCode.map((group) => (
                                      <option
                                        key={group.groupId}
                                        value={group.groupCode}
                                      >
                                        {group.groupCode}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <span>{row.groupCode}</span>
                                )
                              ) : col.name === "action" ? (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setOpenUploadUpdateValuation(true);
                                    setauctioncatalogIdforupload(
                                      row.KutchaCatalogId
                                    );
                                    setGetDataByprems(row);
                                  }}
                                >
                                  <i className="fa fa-edit"></i>
                                </button>
                              ) : row[col.name] === null ? (
                                "-"
                              ) : (
                                row[col.name]
                              )}
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={53}>
                          <div className="NoData">No Records Found</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
      <CreatePlanner
        openMyPlanner={openMyPlanner}
        setOpenMyPlanner={setOpenMyPlanner}
        myCatalogDetails={formik.values}
        isEdit={isEdit}
        editData={editData}
        saleProgramId={saleProgramId}
        sessionTypeId={sessionTypeId}
        modalRight={modalRight}
        baseUrlEng={auctionCatalogUrl}
      />
      <UploadValuation
        openUploadValuation={openUploadValuation}
        setOpenUploadValuation={setOpenUploadValuation}
        auctionCatalogDetail={formik.values}
        loggedUser={loggedUser}
        setMyCatalogRows={setMyCatalogRows}
        timeData={timeData}
        teatypeList={teatypeList}
        userRole={userRole}
        baseUrlEng={
          // userRole === "buyer" ? auctionCatalogUrl :
          auctionCatalogUrl
        }
        kuchacatalogValuaction={false}
      />
      <UpdateValuation
        openUploadUpdateValuation={openUploadUpdateValuation}
        setOpenUploadUpdateValuation={setOpenUploadUpdateValuation}
        getDataByPrems={getDataByPrems}
        auctionCatalogDetail={formik.values}
        setGetDataByprems={setGetDataByprems}
        auctioncatalogIdforupload={auctioncatalogIdforupload}
        baseUrlEng={
          // userRole === "buyer" ? auctionCatalogUrl :
          auctionCatalogUrl
        }
        userRole={userRole}
        resetgetmycatalog={fngetmycatalog}
      />
      <DeleteConfirmationModal
        show={openDelete}
        title={"Are you sure you want to remove ?"}
        onDelete={() => {
          if (userRole === "buyer") {
            let MyCatalogId = selectedRows.join(",");
            // .map((ele) => myCatalogRows[ele])
            // .map(
            //   (ele) =>
            //   (MyCatalogId =
            //     MyCatalogId === ""
            //       ? ele.MyCatalogId?.toString()
            //       : MyCatalogId + "," + ele.MyCatalogId?.toString())
            // );
            openLoader();

            axiosMain
              .post(`/preauction/${auctionCatalogUrl}/RemoveFromMyCatalog`, {
                myCatalogIds: MyCatalogId,
                buyerId: userId,
                auctionCenterId: auctionCenterId,
              })
              .then((res) => {
                if (res.data.statusCode === 200) {
                  CustomToast.success(res.data.message);
                  formik.values.sessionStartTime = timeData
                    ?.split(" - ")
                    ?.at(0);
                  formik.values.sessionEndTime = timeData?.split(" - ")[1];

                  let datatime;
                  let sttime;
                  let endtime;
                  if (
                    formik.values.sessionTime !== "" &&
                    formik.values.sessionTime !== undefined
                  ) {
                    datatime = formik.values.sessionTime.split("-");
                    // sttime = datatime[0].slice(0, -5);
                    // endtime = datatime[1].slice(0, -4);
                    sttime = datatime[0].replace(" ", "");
                    endtime = datatime[1].replace(" ", "");
                  } else {
                    sttime = "";
                    endtime = "";
                  }

                  axiosMain
                    .post(
                      `/preauction/${auctionCatalogUrl}/GetMyCatalog?` +
                        "role=" +
                        loggedUser?.userCode,
                      {
                        season: formik.values.season,
                        saleNo: parseInt(formik.values.saleNo),
                        auctionDate: formik.values.auctionDate,
                        buyerId: userId,
                        // userId: formik.values.auctioneer,
                        sessionTime: formik.values.sessionTime,
                        teaTypeId:
                          teatypeList.filter(
                            (ele) =>
                              ele.teaTypeId === parseInt(formik.values.teaType)
                          )[0]?.teaTypeName === "BOTH"
                            ? 0
                            : parseInt(formik.values.teaType),
                        categoryId: formik.values.category,
                        sessionStartTime: sttime,
                        sessionEndTime: endtime,
                        auctionCenterId: auctionCenterId,

                        gradeId:
                          formik.values.grade === "" ||
                          formik.values.grade === undefined
                            ? 0
                            : parseInt(formik.values.grade),
                        markId:
                          formik.values.mark === "" ||
                          formik.values.mark === undefined
                            ? 0
                            : parseInt(formik.values.mark),
                        origin: formik.values.origin
                          ? formik.values.origin
                          : "",
                      }
                    )
                    .then((res) => {
                      if (res.data.statusCode === 200) {
                        // CustomToast.success(res.data.message);
                        setMyCatalogRows(res.data.responseData);
                        setSelectedData([]);
                        setSelectedDataMyCatalogdata([]);
                        setSelectedRows([]);
                        //set session type id
                        setsessionTypeId(
                          res.data?.responseData[0]?.sessionTypeId
                        );
                        //debugger;
                        setSelectAll(false);
                      } else {
                        //CustomToast.error(res.data.message);
                        setMyCatalogRows([]);
                        setSelectAll(false);
                      }
                      closeLoader();
                    });
                  setSelectedData([]);
                } else {
                  CustomToast.error(res.data.message);
                  setSelectedData([]);
                }
                closeLoader();
              });
          }
          setOpenDelete(false);
        }}
        onHide={() => setOpenDelete(false)}
      />
      {/* MODAL PRINT */}
      <Modals
        size="l"
        title="Select For Print"
        show={openPrintModel}
        handleClose={() => {
          setopenPrintModel(false);
        }}
      >
        <PrintInvoice
          fields={[]}
          showcheckboxlebels={columndata}
          rows={printrow.length > 0 ? printrow : []}
          pageName={"Auction catalog"}
        />
      </Modals>
      {/* MODAL PRINT */}
      <Modals
        size="l"
        title="Select For Print"
        show={openPrintModelMyCatalog}
        handleClose={() => {
          setopenPrintModelMyCatalog(false);
        }}
      >
        <PrintInvoice
          fields={[]}
          showcheckboxlebels={columndatamycatalog}
          rows={printMyrow.length > 0 ? printMyrow : []}
          pageName={"My catalog"}
        />
      </Modals>

      {/* confirmation model 422*/}
      <Modals
        show={openModalConformation}
        size="xl"
        // onHide={() => setShow(false)}
        handleClose={() => {
          setOpenModalConformation(false);
          setDataFlag(false);
        }}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        title="Confirmation Message"
      >
        <div>
          <ul>{openModalConformationTitle}</ul>
        </div>
        {baseUrlEng === "EnglishAuctionKutchaCatalogue" && (
          <>
            <br />
            <div>
              <ul>
                ● If you want the system to automatically delete the associated
                sample and shortage data for the packages click{" "}
                <b>Yes, Delete and Proceed</b>
              </ul>

              <ul>
                ● If you want to keep the existing sample and shortage data and
                delete package no. manually, click <b>NO, Manually Delete</b>
              </ul>
            </div>
          </>
        )}
        <div className="BtnGroup" style={{ justifyContent: "end" }}>
          {baseUrlEng === "EnglishAuctionKutchaCatalogue" ? (
            <>
              <button
                // className="SubmitBtn"
                className="SubmitBtn"
                type="button"
                onClick={() => {
                  // formik.handleSubmit();
                  commitChanges(changed);
                }}
              >
                Yes, Delete and Proceed
              </button>

              <button
                type="button"
                className="SubmitBtn"
                // className="SubmitBtn"
                onClick={() => {
                  setDataFlag(false);
                  setOpenModalConformation(false);
                }}
              >
                NO, Manually Delete
              </button>
            </>
          ) : (
            <>
              <button
                // className="SubmitBtn"
                className="SubmitBtn"
                type="button"
                onClick={() => {
                  commitChanges(changed);
                }}
              >
                Yes
              </button>

              <button
                type="button"
                className="SubmitBtn"
                // className="SubmitBtn"
                onClick={() => {
                  setDataFlag(false);
                  setOpenModalConformation(false);
                }}
              >
                No
              </button>
            </>
          )}
        </div>
      </Modals>
    </div>
  );
};

export default AuctionCatalog;
